"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9751],{

/***/ 92980:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/placeholder-image.a7c8cb48.jpeg","height":612,"width":612,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAaEAACAgMAAAAAAAAAAAAAAAAAEQECEhNR/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AKAqa25z4AAP/9k="});

/***/ }),

/***/ 89765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eh": function() { return /* binding */ useFetchPromotedList; },
/* harmony export */   "T0": function() { return /* binding */ useFetchDmchietkhauByMaVt; }
/* harmony export */ });
/* unused harmony exports fetchPromotedList, fetchDmchietkhau, useFetchDmchietkhauByMaTt */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_lodash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59926);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67848);
/* harmony import */ var just_unique__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20335);
/* harmony import */ var _fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36203);
/* harmony import */ var _queryKeys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76296);







var fetchPromotedList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var signal, data, ma_vt_list;
        return _var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    signal = param.signal;
                    _ctx.next = 3;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncSearchList */ .Xz)({
                        access_token: "flex.public.token",
                        collection_name: "dmchietkhau",
                        options: {
                            limit: 200,
                            fields: [
                                "hieu_luc_tu",
                                "hieu_luc_den",
                                "ma_vt"
                            ]
                        },
                        signal: signal
                    });
                case 3:
                    data = _ctx.sent;
                    ma_vt_list = (data || []).sort(function(a, b) {
                        return b.tien_ck - a.tien_ck;
                    }).map(function(el) {
                        return el.ma_vt;
                    });
                    return _ctx.abrupt("return", (0,just_unique__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ma_vt_list));
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchPromotedList(_) {
        return _ref.apply(this, arguments);
    };
}();
var fetchDmchietkhau = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(condition) {
        return _var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(!condition || (0,_utils_lodash__WEBPACK_IMPORTED_MODULE_5__/* .isEmpty */ .xb)(condition))) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    _ctx.next = 4;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncSearchList */ .Xz)({
                        access_token: "flex.public.token",
                        collection_name: "dmchietkhau",
                        options: {
                            condition: condition
                        }
                    });
                case 4:
                    return _ctx.abrupt("return", _ctx.sent);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchDmchietkhau(condition) {
        return _ref.apply(this, arguments);
    };
}();
var useFetchDmchietkhauByMaVt = function(param) {
    var ma_vt = param.ma_vt, _enabled = param.enabled, enabled = _enabled === void 0 ? true : _enabled;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .dmchietkhauKeys.list */ .bT.list(ma_vt), function() {
        return fetchDmchietkhau({
            ma_vt: ma_vt
        });
    }, {
        enabled: !!ma_vt && enabled,
        staleTime: 1000 * 60 * 60
    });
};
var useFetchDmchietkhauByMaTt = function(param) {
    var ma_tt = param.ma_tt, _enabled = param.enabled, enabled = _enabled === void 0 ? true : _enabled;
    return useQuery(dmchietkhauKeys.detail(ma_tt), function() {
        return fetchDmchietkhau({
            ma_tt: ma_tt
        });
    }, {
        enabled: !!ma_tt && enabled,
        staleTime: 1000 * 60 * 60
    });
};
var useFetchPromotedList = function() {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .dmchietkhauKeys.all */ .bT.all(), function(param) {
        var signal = param.signal;
        return fetchPromotedList({
            signal: signal
        });
    }, {
        staleTime: 1000 * 60 * 60
    });
};


/***/ }),

/***/ 60637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "KA": function() { return /* binding */ useFetchDmtt; },
  "m9": function() { return /* binding */ useFetchDmttList; }
});

// UNUSED EXPORTS: fetchAllDmtt, fetchDmtt

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(67848);
// EXTERNAL MODULE: ./apis/fetch.js
var fetch = __webpack_require__(36203);
;// CONCATENATED MODULE: ./apis/queryKeys/dmttKeys.js

var sort = {
    date_created: -1
};
// export const INITIAL_LOADING_NEWS_OPTIONS = {
//   limit: process.env.NEWS_LOADING_LIMIT,
//   condition: {
//     ngon_ngu: "vi",
//   },
// };
var dmttKeys = {
    // all: [{ scope: "dmtt", limit: 100, sort }],
    // count: (options) => [
    //   {
    //     scope: "dmtt",
    //     type: "count",
    //     ...flattenObj(options || {}),
    //   },
    // ],
    list: function() {
        return [
            {
                scope: "dmtt",
                type: "list"
            }, 
        ];
    },
    detail: function(ma_vt) {
        return [
            {
                scope: "dmtt",
                type: "detail",
                ma_vt: ma_vt
            }
        ];
    }
};
/* harmony default export */ var queryKeys_dmttKeys = (dmttKeys);

;// CONCATENATED MODULE: ./apis/queryFunctions/initialData/dmtt.json
var dmtt_namespaceObject = JSON.parse('[{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"39","ma_vt":"F031164"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"37","ma_vt":"F031164"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"40","ma_vt":"F031164"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F031164"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"37","ma_vt":"F031164"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"39","ma_vt":"F031164"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"36","ma_vt":"F031164"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F031164"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"36","ma_vt":"F031164"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F031164"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"38","ma_vt":"F031164"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"35","ma_vt":"F031164"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"40","ma_vt":"F031164"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F031164"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"38","ma_vt":"F031164"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F031164"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F031164"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"35","ma_vt":"F031164"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"36","ma_vt":"F031163"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"37","ma_vt":"F031163"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"38","ma_vt":"F031163"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"35","ma_vt":"F031163"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F031163"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F031163"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"40","ma_vt":"F031163"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"39","ma_vt":"F031163"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F031163"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"38","ma_vt":"F031163"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"39","ma_vt":"F031163"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F031163"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F031163"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"37","ma_vt":"F031163"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"35","ma_vt":"F031163"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"40","ma_vt":"F031163"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F031163"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"36","ma_vt":"F031163"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"39","ma_vt":"F041147"},{"gia_tri_bien_the_1":"hồng","gia_tri_bien_the_2":"38","ma_vt":"F041147"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"40","ma_vt":"F041147"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"40","ma_vt":"F041147"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"35","ma_vt":"F041147"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"37","ma_vt":"F041147"},{"gia_tri_bien_the_1":"hồng","gia_tri_bien_the_2":"40","ma_vt":"F041147"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"35","ma_vt":"F041147"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"38","ma_vt":"F041147"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"38","ma_vt":"F041147"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"36","ma_vt":"F041147"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"39","ma_vt":"F041147"},{"gia_tri_bien_the_1":"hồng","gia_tri_bien_the_2":"37","ma_vt":"F041147"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"36","ma_vt":"F041147"},{"gia_tri_bien_the_1":"hồng","gia_tri_bien_the_2":"35","ma_vt":"F041147"},{"gia_tri_bien_the_1":"hồng","gia_tri_bien_the_2":"36","ma_vt":"F041147"},{"gia_tri_bien_the_1":"hồng","gia_tri_bien_the_2":"39","ma_vt":"F041147"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"37","ma_vt":"F041147"},{"gia_tri_bien_the_1":"kem mờ","gia_tri_bien_the_2":"38","ma_vt":"ZF027149"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"ZF027149"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"ZF027149"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"ZF027149"},{"gia_tri_bien_the_1":"kem mờ","gia_tri_bien_the_2":"40","ma_vt":"ZF027149"},{"gia_tri_bien_the_1":"kem mờ","gia_tri_bien_the_2":"37","ma_vt":"ZF027149"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"ZF027149"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"ZF027149"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"ZF027149"},{"gia_tri_bien_the_1":"kem mờ","gia_tri_bien_the_2":"35","ma_vt":"ZF027149"},{"gia_tri_bien_the_1":"kem mờ","gia_tri_bien_the_2":"36","ma_vt":"ZF027149"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"ZF027149"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"ZF027149"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"ZF027149"},{"gia_tri_bien_the_1":"kem mờ","gia_tri_bien_the_2":"39","ma_vt":"ZF027149"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"ZF027149"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"ZF027149"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"ZF027149"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"ZF025150"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"ZF025150"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"ZF025150"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"ZF025150"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"ZF025150"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"39","ma_vt":"ZF025150"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"36","ma_vt":"ZF025150"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"ZF025150"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"35","ma_vt":"ZF025150"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"ZF025150"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"ZF025150"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"ZF025150"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"ZF025150"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"ZF025150"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"ZF025150"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"40","ma_vt":"ZF025150"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"38","ma_vt":"ZF025150"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"37","ma_vt":"ZF025150"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"ZF025148"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"ZF025148"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"38","ma_vt":"ZF025148"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"ZF025148"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"ZF025148"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"35","ma_vt":"ZF025148"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"39","ma_vt":"ZF025148"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"ZF025148"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"ZF025148"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"ZF025148"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"37","ma_vt":"ZF025148"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"ZF025148"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"ZF025148"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"36","ma_vt":"ZF025148"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"ZF025148"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F061167"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"35","ma_vt":"F061167"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"38","ma_vt":"ZF061151"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"ZF061151"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"39","ma_vt":"ZF061151"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"ZF061151"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"40","ma_vt":"ZF061151"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"36","ma_vt":"ZF061151"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"ZF061151"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"ZF061151"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"35","ma_vt":"ZF061151"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"ZF061151"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"37","ma_vt":"ZF061151"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"ZF061151"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"ZF061151"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"ZF061151"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"ZF061151"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"ZF061151"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"ZF061151"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"ZF061151"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"35","ma_vt":"F061167"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"35","ma_vt":"F061167"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"39","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"nhũ bạc","gia_tri_bien_the_2":"39","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"36","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"nhũ bạc","gia_tri_bien_the_2":"35","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"38","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"nhũ bạc","gia_tri_bien_the_2":"37","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"nhũ bạc","gia_tri_bien_the_2":"36","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"40","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"nhũ bạc","gia_tri_bien_the_2":"40","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"37","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"35","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"nhũ bạc","gia_tri_bien_the_2":"38","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"xanh mint","gia_tri_bien_the_2":"40","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"xanh mint","gia_tri_bien_the_2":"38","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"xanh mint","gia_tri_bien_the_2":"39","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"xanh mint","gia_tri_bien_the_2":"37","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"xanh mint","gia_tri_bien_the_2":"36","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"xanh mint","gia_tri_bien_the_2":"35","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"ZF061152"},{"gia_tri_bien_the_1":"tím","gia_tri_bien_the_2":"36","ma_vt":"ZF041155"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"40","ma_vt":"ZF041155"},{"gia_tri_bien_the_1":"hồng","gia_tri_bien_the_2":"36","ma_vt":"ZF041155"},{"gia_tri_bien_the_1":"hồng","gia_tri_bien_the_2":"39","ma_vt":"ZF041155"},{"gia_tri_bien_the_1":"tím","gia_tri_bien_the_2":"35","ma_vt":"ZF041155"},{"gia_tri_bien_the_1":"tím","gia_tri_bien_the_2":"38","ma_vt":"ZF041155"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"37","ma_vt":"ZF041155"},{"gia_tri_bien_the_1":"tím","gia_tri_bien_the_2":"39","ma_vt":"ZF041155"},{"gia_tri_bien_the_1":"tím","gia_tri_bien_the_2":"40","ma_vt":"ZF041155"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"36","ma_vt":"ZF041155"},{"gia_tri_bien_the_1":"tím","gia_tri_bien_the_2":"37","ma_vt":"ZF041155"},{"gia_tri_bien_the_1":"hồng","gia_tri_bien_the_2":"37","ma_vt":"ZF041155"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"39","ma_vt":"ZF041155"},{"gia_tri_bien_the_1":"hồng","gia_tri_bien_the_2":"35","ma_vt":"ZF041155"},{"gia_tri_bien_the_1":"hồng","gia_tri_bien_the_2":"40","ma_vt":"ZF041155"},{"gia_tri_bien_the_1":"hồng","gia_tri_bien_the_2":"38","ma_vt":"ZF041155"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"35","ma_vt":"ZF041155"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"38","ma_vt":"ZF041155"},{"gia_tri_bien_the_1":"xanh navy","gia_tri_bien_the_2":"39","ma_vt":"ZF041156"},{"gia_tri_bien_the_1":"xanh mint","gia_tri_bien_the_2":"36","ma_vt":"ZF041156"},{"gia_tri_bien_the_1":"xanh navy","gia_tri_bien_the_2":"40","ma_vt":"ZF041156"},{"gia_tri_bien_the_1":"xanh navy","gia_tri_bien_the_2":"37","ma_vt":"ZF041156"},{"gia_tri_bien_the_1":"xanh mint","gia_tri_bien_the_2":"35","ma_vt":"ZF041156"},{"gia_tri_bien_the_1":"xanh mint","gia_tri_bien_the_2":"37","ma_vt":"ZF041156"},{"gia_tri_bien_the_1":"xanh mint","gia_tri_bien_the_2":"40","ma_vt":"ZF041156"},{"gia_tri_bien_the_1":"tím","gia_tri_bien_the_2":"37","ma_vt":"ZF041156"},{"gia_tri_bien_the_1":"xanh mint","gia_tri_bien_the_2":"39","ma_vt":"ZF041156"},{"gia_tri_bien_the_1":"xanh mint","gia_tri_bien_the_2":"38","ma_vt":"ZF041156"},{"gia_tri_bien_the_1":"tím","gia_tri_bien_the_2":"36","ma_vt":"ZF041156"},{"gia_tri_bien_the_1":"tím","gia_tri_bien_the_2":"35","ma_vt":"ZF041156"},{"gia_tri_bien_the_1":"tím","gia_tri_bien_the_2":"40","ma_vt":"ZF041156"},{"gia_tri_bien_the_1":"xanh navy","gia_tri_bien_the_2":"38","ma_vt":"ZF041156"},{"gia_tri_bien_the_1":"xanh navy","gia_tri_bien_the_2":"35","ma_vt":"ZF041156"},{"gia_tri_bien_the_1":"tím","gia_tri_bien_the_2":"39","ma_vt":"ZF041156"},{"gia_tri_bien_the_1":"xanh navy","gia_tri_bien_the_2":"36","ma_vt":"ZF041156"},{"gia_tri_bien_the_1":"tím","gia_tri_bien_the_2":"38","ma_vt":"ZF041156"},{"gia_tri_bien_the_1":"xanh navy","gia_tri_bien_the_2":"36","ma_vt":"ZF031157"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"ZF031157"},{"gia_tri_bien_the_1":"xanh navy","gia_tri_bien_the_2":"38","ma_vt":"ZF031157"},{"gia_tri_bien_the_1":"xanh navy","gia_tri_bien_the_2":"35","ma_vt":"ZF031157"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"ZF031157"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"ZF031157"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"ZF031157"},{"gia_tri_bien_the_1":"xanh navy","gia_tri_bien_the_2":"39","ma_vt":"ZF031157"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"ZF031157"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"ZF031157"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"ZF031157"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"ZF031157"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"ZF031157"},{"gia_tri_bien_the_1":"xanh navy","gia_tri_bien_the_2":"37","ma_vt":"ZF031157"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"ZF031157"},{"gia_tri_bien_the_1":"xanh navy","gia_tri_bien_the_2":"40","ma_vt":"ZF031157"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"ZF031157"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"ZF031157"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"ZF031158"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"40","ma_vt":"ZF031158"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"39","ma_vt":"ZF031158"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"ZF031158"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"ZF031158"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"ZF031158"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"37","ma_vt":"ZF031158"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"ZF031158"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"ZF031158"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"36","ma_vt":"ZF031158"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"38","ma_vt":"ZF031158"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"ZF031158"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"ZF031158"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"ZF031158"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"ZF031158"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"ZF031158"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"35","ma_vt":"ZF031158"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"ZF031158"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"40","ma_vt":"ZD071159"},{"gia_tri_bien_the_1":"nâu","gia_tri_bien_the_2":"39","ma_vt":"ZD071159"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"38","ma_vt":"ZD071159"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"39","ma_vt":"ZD071159"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"35","ma_vt":"ZD071159"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"37","ma_vt":"ZD071159"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"36","ma_vt":"ZD071159"},{"gia_tri_bien_the_1":"nâu","gia_tri_bien_the_2":"36","ma_vt":"ZD071159"},{"gia_tri_bien_the_1":"nâu","gia_tri_bien_the_2":"40","ma_vt":"ZD071159"},{"gia_tri_bien_the_1":"nâu","gia_tri_bien_the_2":"38","ma_vt":"ZD071159"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"38","ma_vt":"ZD071159"},{"gia_tri_bien_the_1":"nâu","gia_tri_bien_the_2":"35","ma_vt":"ZD071159"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"36","ma_vt":"ZD071159"},{"gia_tri_bien_the_1":"nâu","gia_tri_bien_the_2":"37","ma_vt":"ZD071159"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"39","ma_vt":"ZD071159"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"35","ma_vt":"ZD071159"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"40","ma_vt":"ZD071159"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"37","ma_vt":"ZD071159"},{"gia_tri_bien_the_1":"rêu","gia_tri_bien_the_2":"37","ma_vt":"ZF065162"},{"gia_tri_bien_the_1":"rêu","gia_tri_bien_the_2":"38","ma_vt":"ZF065162"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"35","ma_vt":"ZF065162"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"ZF065162"},{"gia_tri_bien_the_1":"rêu","gia_tri_bien_the_2":"40","ma_vt":"ZF065162"},{"gia_tri_bien_the_1":"rêu","gia_tri_bien_the_2":"35","ma_vt":"ZF065162"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"38","ma_vt":"ZF065162"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"39","ma_vt":"ZF065162"},{"gia_tri_bien_the_1":"rêu","gia_tri_bien_the_2":"36","ma_vt":"ZF065162"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"40","ma_vt":"ZF065162"},{"gia_tri_bien_the_1":"rêu","gia_tri_bien_the_2":"39","ma_vt":"ZF065162"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"36","ma_vt":"ZF065162"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"ZF065162"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"ZF065162"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"ZF065162"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"ZF065162"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"ZF065162"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"37","ma_vt":"ZF065162"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"ZF065163"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"ZF065163"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"ZF065163"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"ZF065163"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"35","ma_vt":"ZF065163"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"ZF065163"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"ZF065163"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"ZF065163"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"40","ma_vt":"ZF065163"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"ZF065163"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"ZF065163"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"39","ma_vt":"ZF065163"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"ZF065163"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"ZF065163"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"ZF065163"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"37","ma_vt":"ZF065163"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"36","ma_vt":"ZF065163"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"38","ma_vt":"ZF065163"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"38","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"35","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"36","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"40","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"39","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"37","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"37","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"40","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"35","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"38","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"39","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"36","ma_vt":"ZF025164"},{"gia_tri_bien_the_1":"nâu","gia_tri_bien_the_2":"41","ma_vt":"FD04"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"41","ma_vt":"FD05"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"39","ma_vt":"FD05"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"FD05"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"43","ma_vt":"FD04"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"FD06"},{"gia_tri_bien_the_1":"nâu","gia_tri_bien_the_2":"40","ma_vt":"FD04"},{"gia_tri_bien_the_1":"nâu","gia_tri_bien_the_2":"43","ma_vt":"FD04"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"42","ma_vt":"FD05"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"43","ma_vt":"FD06"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"43","ma_vt":"FD05"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"43","ma_vt":"FD05"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"43","ma_vt":"FD05"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"42","ma_vt":"FD06"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"43","ma_vt":"FD06"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"FD06"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"41","ma_vt":"FD05"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"40","ma_vt":"FD06"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"FD05"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"40","ma_vt":"FD06"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"41","ma_vt":"FD05"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"39","ma_vt":"FD06"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"41","ma_vt":"FD04"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"41","ma_vt":"FD06"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"42","ma_vt":"FD05"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"42","ma_vt":"FD05"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"41","ma_vt":"FD06"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"43","ma_vt":"FD06"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"40","ma_vt":"FD04"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"42","ma_vt":"FD06"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"42","ma_vt":"FD06"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"39","ma_vt":"FD04"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"42","ma_vt":"FD04"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"FD05"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"39","ma_vt":"FD06"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"FD05"},{"gia_tri_bien_the_1":"nâu","gia_tri_bien_the_2":"42","ma_vt":"FD04"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"40","ma_vt":"FD05"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"41","ma_vt":"FD06"},{"gia_tri_bien_the_1":"nâu","gia_tri_bien_the_2":"39","ma_vt":"FD04"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F041104"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"36","ma_vt":"F041104"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F041104"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"37","ma_vt":"F041104"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"40","ma_vt":"F041104"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F041104"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"39","ma_vt":"F041104"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F041104"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"35","ma_vt":"F041104"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"38","ma_vt":"F041104"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F041104"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F041104"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"35","ma_vt":"F041103"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"39","ma_vt":"F041103"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F041103"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"36","ma_vt":"F041103"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"35","ma_vt":"F041103"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"36","ma_vt":"F041103"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"38","ma_vt":"F041103"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F041103"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"37","ma_vt":"F041103"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"39","ma_vt":"F041103"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"40","ma_vt":"F041103"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"37","ma_vt":"F041103"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"38","ma_vt":"F041103"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F041103"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"40","ma_vt":"F041103"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F041103"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F041103"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F041103"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F061043"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F061043"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F061043"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F061043"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F061043"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"40","ma_vt":"F061043"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"38","ma_vt":"F061043"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"35","ma_vt":"F061043"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"36","ma_vt":"F061043"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F061043"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F061043"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F061043"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"37","ma_vt":"F061043"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"39","ma_vt":"F061043"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F061043"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F061043"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F061043"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F061043"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"40","ma_vt":"F061084"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F061084"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"38","ma_vt":"F061084"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F061084"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"35","ma_vt":"F061084"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F061084"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F061084"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"36","ma_vt":"F061084"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F061084"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"39","ma_vt":"F061084"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F061084"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F061084"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"37","ma_vt":"F061084"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F061084"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F061084"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F061084"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F061084"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F061084"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F041090"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F041090"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F041090"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F041090"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F041090"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"40","ma_vt":"F041090"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"37","ma_vt":"F041090"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"35","ma_vt":"F041090"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"39","ma_vt":"F041090"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"38","ma_vt":"F041090"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"35","ma_vt":"F041090"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F041090"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"37","ma_vt":"F041090"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"39","ma_vt":"F041090"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"40","ma_vt":"F041090"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"36","ma_vt":"F041090"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"38","ma_vt":"F041090"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"36","ma_vt":"F041090"},{"gia_tri_bien_the_1":"nâu bò","gia_tri_bien_the_2":"43","ma_vt":"FTN01"},{"gia_tri_bien_the_1":"nâu bò","gia_tri_bien_the_2":"42","ma_vt":"FTN01"},{"gia_tri_bien_the_1":"nâu bò","gia_tri_bien_the_2":"39","ma_vt":"FTN01"},{"gia_tri_bien_the_1":"nâu bò","gia_tri_bien_the_2":"40","ma_vt":"FTN01"},{"gia_tri_bien_the_1":"nâu bò","gia_tri_bien_the_2":"41","ma_vt":"FTN01"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"40","ma_vt":"F061068"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F061068"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"38","ma_vt":"F061068"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F061068"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"36","ma_vt":"F061068"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"37","ma_vt":"F061068"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"35","ma_vt":"F061068"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F061068"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F061068"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F061068"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F061068"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"39","ma_vt":"F061068"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"36","ma_vt":"F041073"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F041073"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"40","ma_vt":"F041073"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F041073"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F041073"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"38","ma_vt":"F041073"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F041073"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F041073"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"35","ma_vt":"F041073"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F041073"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F041073"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F041073"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"37","ma_vt":"F041073"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F041073"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F041073"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"39","ma_vt":"F041073"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F041073"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F041073"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F061054"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"37","ma_vt":"F061054"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F061054"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"37","ma_vt":"F061054"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F061054"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"35","ma_vt":"F061054"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"38","ma_vt":"F061054"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"38","ma_vt":"F061054"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F061054"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F061054"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"36","ma_vt":"F061054"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F061054"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F061054"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F061054"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"39","ma_vt":"F061054"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"40","ma_vt":"F061054"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F061054"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"38","ma_vt":"F061054"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"35","ma_vt":"F061054"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"36","ma_vt":"F061054"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F061054"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F061054"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"37","ma_vt":"F061054"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"40","ma_vt":"F061054"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"40","ma_vt":"F061054"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"36","ma_vt":"F061054"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"39","ma_vt":"F061054"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"39","ma_vt":"F061054"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F061054"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"35","ma_vt":"F061054"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"39","ma_vt":"F061050"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F061050"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"40","ma_vt":"F061050"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F061050"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F061050"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"35","ma_vt":"F061050"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"36","ma_vt":"F061050"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F061050"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F061050"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F061050"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F061050"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F061050"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F061050"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F061050"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F061050"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"38","ma_vt":"F061050"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F061050"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"37","ma_vt":"F061050"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"36","ma_vt":"F061025"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"35","ma_vt":"F061025"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F061025"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F061025"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F061025"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"36","ma_vt":"F061025"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"40","ma_vt":"F061025"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"37","ma_vt":"F061025"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"36","ma_vt":"F061025"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"35","ma_vt":"F061025"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"40","ma_vt":"F061025"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F061025"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"39","ma_vt":"F061025"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F061025"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"37","ma_vt":"F061025"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"40","ma_vt":"F061025"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"39","ma_vt":"F061025"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F061025"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"38","ma_vt":"F061025"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"35","ma_vt":"F061025"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F061025"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"39","ma_vt":"F061025"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"38","ma_vt":"F061025"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F061025"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F061025"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F061025"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"38","ma_vt":"F061025"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F061025"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"37","ma_vt":"F061025"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F061025"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"38","ma_vt":"F061167"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"37","ma_vt":"F061167"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"36","ma_vt":"F061167"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"39","ma_vt":"F061167"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"40","ma_vt":"F061167"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"38","ma_vt":"F061167"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"39","ma_vt":"F061167"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"40","ma_vt":"F061167"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"36","ma_vt":"F061167"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F061167"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F061167"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F061167"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F061167"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F061167"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"37","ma_vt":"F061167"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F061167"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F061167"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F061167"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F061167"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"37","ma_vt":"F061167"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"38","ma_vt":"F061167"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"39","ma_vt":"F061167"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"40","ma_vt":"F061167"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"36","ma_vt":"F061167"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F061167"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F025100"},{"gia_tri_bien_the_1":"xanh dương","gia_tri_bien_the_2":"39","ma_vt":"F025100"},{"gia_tri_bien_the_1":"xanh dương","gia_tri_bien_the_2":"35","ma_vt":"F025100"},{"gia_tri_bien_the_1":"xanh dương","gia_tri_bien_the_2":"38","ma_vt":"F025100"},{"gia_tri_bien_the_1":"xanh dương","gia_tri_bien_the_2":"36","ma_vt":"F025100"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F025100"},{"gia_tri_bien_the_1":"xanh dương","gia_tri_bien_the_2":"37","ma_vt":"F025100"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F025100"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F025100"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F025100"},{"gia_tri_bien_the_1":"xanh dương","gia_tri_bien_the_2":"40","ma_vt":"F025100"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F025100"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"39","ma_vt":"F025101"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"40","ma_vt":"F025101"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"38","ma_vt":"F025101"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"37","ma_vt":"F025101"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"35","ma_vt":"F025101"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"35","ma_vt":"F025101"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"40","ma_vt":"F025101"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"36","ma_vt":"F025101"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"38","ma_vt":"F025101"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"37","ma_vt":"F025101"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"36","ma_vt":"F025101"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"39","ma_vt":"F025101"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F025077"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F025077"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F025077"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"39","ma_vt":"F025077"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F025077"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F025077"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F025077"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F025077"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F025077"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F025077"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F025077"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"40","ma_vt":"F025077"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"37","ma_vt":"F025077"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"35","ma_vt":"F025077"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F025077"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"38","ma_vt":"F025077"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"36","ma_vt":"F025077"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F025077"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"36","ma_vt":"F025097"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"40","ma_vt":"F025097"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F025097"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F025097"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"35","ma_vt":"F025097"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F025097"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F025097"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F025097"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F025097"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"39","ma_vt":"F025097"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F025097"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F025097"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F025097"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F025097"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"38","ma_vt":"F025097"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F025097"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"37","ma_vt":"F025097"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F025097"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F025082"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"40","ma_vt":"F025082"},{"gia_tri_bien_the_1":"xanh dương","gia_tri_bien_the_2":"37","ma_vt":"F025082"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"39","ma_vt":"F025082"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F025082"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F025082"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F025082"},{"gia_tri_bien_the_1":"xanh dương","gia_tri_bien_the_2":"38","ma_vt":"F025082"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"39","ma_vt":"F025082"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F025082"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F025082"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"38","ma_vt":"F025082"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F025082"},{"gia_tri_bien_the_1":"xanh dương","gia_tri_bien_the_2":"39","ma_vt":"F025082"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"35","ma_vt":"F025082"},{"gia_tri_bien_the_1":"xanh dương","gia_tri_bien_the_2":"40","ma_vt":"F025082"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"36","ma_vt":"F025082"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F025082"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"38","ma_vt":"F025082"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"35","ma_vt":"F025082"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"40","ma_vt":"F025082"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"36","ma_vt":"F025082"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"37","ma_vt":"F025082"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F025082"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F025082"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F025082"},{"gia_tri_bien_the_1":"xanh dương","gia_tri_bien_the_2":"36","ma_vt":"F025082"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"37","ma_vt":"F025082"},{"gia_tri_bien_the_1":"xanh dương","gia_tri_bien_the_2":"35","ma_vt":"F025082"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F025082"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"39","ma_vt":"F013096"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F013096"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"38","ma_vt":"F013096"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"37","ma_vt":"F013096"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"40","ma_vt":"F013096"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"36","ma_vt":"F013096"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F013096"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F013096"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F013096"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F013096"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F013096"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"35","ma_vt":"F013096"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"40","ma_vt":"F025081"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F025081"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"39","ma_vt":"F025081"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"39","ma_vt":"F025081"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"35","ma_vt":"F025081"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"37","ma_vt":"F025081"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"36","ma_vt":"F025081"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F025081"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F025081"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F025081"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"38","ma_vt":"F025081"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"38","ma_vt":"F025081"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"36","ma_vt":"F025081"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F025081"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F025081"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"35","ma_vt":"F025081"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"40","ma_vt":"F025081"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"37","ma_vt":"F025081"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F025094"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F025094"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F025094"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"35","ma_vt":"F025094"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F025094"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"40","ma_vt":"F025094"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"39","ma_vt":"F025094"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F025094"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"38","ma_vt":"F025094"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F025094"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F025094"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F025094"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F025094"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F025094"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"36","ma_vt":"F025094"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F025094"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"37","ma_vt":"F025094"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F025094"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"40","ma_vt":"F025091"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"39","ma_vt":"F025091"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F025091"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"38","ma_vt":"F025091"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"37","ma_vt":"F025091"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"40","ma_vt":"F025091"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F025091"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"36","ma_vt":"F025091"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F025091"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"39","ma_vt":"F025091"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"35","ma_vt":"F025091"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"35","ma_vt":"F025091"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"37","ma_vt":"F025091"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"38","ma_vt":"F025091"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"36","ma_vt":"F025091"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F025091"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F025091"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F025091"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F025092"},{"gia_tri_bien_the_1":"hồng","gia_tri_bien_the_2":"36","ma_vt":"F025092"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F025092"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"38","ma_vt":"F025092"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"35","ma_vt":"F025092"},{"gia_tri_bien_the_1":"hồng","gia_tri_bien_the_2":"35","ma_vt":"F025092"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"39","ma_vt":"F025092"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F025092"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"37","ma_vt":"F025092"},{"gia_tri_bien_the_1":"hồng","gia_tri_bien_the_2":"39","ma_vt":"F025092"},{"gia_tri_bien_the_1":"hồng","gia_tri_bien_the_2":"40","ma_vt":"F025092"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"40","ma_vt":"F025092"},{"gia_tri_bien_the_1":"xanh da trời","gia_tri_bien_the_2":"36","ma_vt":"F025092"},{"gia_tri_bien_the_1":"hồng","gia_tri_bien_the_2":"38","ma_vt":"F025092"},{"gia_tri_bien_the_1":"hồng","gia_tri_bien_the_2":"37","ma_vt":"F025092"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F025092"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F025092"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F025092"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F031087"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F031087"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F031087"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F031087"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"39","ma_vt":"F031087"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F031087"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"37","ma_vt":"F031087"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"38","ma_vt":"F031087"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"35","ma_vt":"F031087"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F031087"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F031087"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"40","ma_vt":"F031087"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F031087"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F031087"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F031087"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F031087"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"36","ma_vt":"F031087"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F031087"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F031086"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"36","ma_vt":"F031086"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F031086"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F031086"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"40","ma_vt":"F031086"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"40","ma_vt":"F031086"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"38","ma_vt":"F031086"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"35","ma_vt":"F031086"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"36","ma_vt":"F031086"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F031086"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F031086"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F031086"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"37","ma_vt":"F031086"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"39","ma_vt":"F031086"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"37","ma_vt":"F031086"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"35","ma_vt":"F031086"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"38","ma_vt":"F031086"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"39","ma_vt":"F031086"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"36","ma_vt":"F017056"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F017056"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"38","ma_vt":"F017056"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"35","ma_vt":"F017056"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F017056"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F017056"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F017056"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"39","ma_vt":"F017056"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F017056"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F017056"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F017056"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F017056"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F017056"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"37","ma_vt":"F017056"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F017056"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"40","ma_vt":"F017056"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F017056"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F017056"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"40","ma_vt":"F031071"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"39","ma_vt":"F031071"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F031071"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"38","ma_vt":"F031071"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"36","ma_vt":"F031071"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"36","ma_vt":"F031071"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"35","ma_vt":"F031071"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"38","ma_vt":"F031071"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"37","ma_vt":"F031071"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"35","ma_vt":"F031071"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"39","ma_vt":"F031071"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"37","ma_vt":"F031071"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F031071"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F031071"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"40","ma_vt":"F031071"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F031071"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F031071"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F031071"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F031072"},{"gia_tri_bien_the_1":"bạc","gia_tri_bien_the_2":"40","ma_vt":"F031072"},{"gia_tri_bien_the_1":"bạc","gia_tri_bien_the_2":"35","ma_vt":"F031072"},{"gia_tri_bien_the_1":"bạc","gia_tri_bien_the_2":"39","ma_vt":"F031072"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F031072"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F031072"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F031072"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F031072"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F031072"},{"gia_tri_bien_the_1":"bạc","gia_tri_bien_the_2":"37","ma_vt":"F031072"},{"gia_tri_bien_the_1":"bạc","gia_tri_bien_the_2":"38","ma_vt":"F031072"},{"gia_tri_bien_the_1":"bạc","gia_tri_bien_the_2":"36","ma_vt":"F031072"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"36","ma_vt":"F025052"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"40","ma_vt":"F025052"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F025052"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"39","ma_vt":"F025052"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F025052"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F025052"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F025052"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F025052"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F025052"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F025052"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"37","ma_vt":"F025052"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"38","ma_vt":"F025052"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F025052"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F025052"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"35","ma_vt":"F025052"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F025052"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F025052"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F025052"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F025026"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"40","ma_vt":"F025026"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"37","ma_vt":"F025026"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F025026"},{"gia_tri_bien_the_1":"xanh dương","gia_tri_bien_the_2":"40","ma_vt":"F025026"},{"gia_tri_bien_the_1":"xanh dương","gia_tri_bien_the_2":"36","ma_vt":"F025026"},{"gia_tri_bien_the_1":"xanh dương","gia_tri_bien_the_2":"39","ma_vt":"F025026"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"37","ma_vt":"F025026"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F025026"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"36","ma_vt":"F025026"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F025026"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F025026"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"35","ma_vt":"F025026"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"39","ma_vt":"F025026"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"38","ma_vt":"F025026"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F025026"},{"gia_tri_bien_the_1":"xanh dương","gia_tri_bien_the_2":"35","ma_vt":"F025026"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F025026"},{"gia_tri_bien_the_1":"xanh dương","gia_tri_bien_the_2":"38","ma_vt":"F025026"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"40","ma_vt":"F025026"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"39","ma_vt":"F025026"},{"gia_tri_bien_the_1":"xanh ngọc","gia_tri_bien_the_2":"38","ma_vt":"F025026"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"36","ma_vt":"F025026"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F025026"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F025026"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"35","ma_vt":"F025026"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F025026"},{"gia_tri_bien_the_1":"xanh dương","gia_tri_bien_the_2":"37","ma_vt":"F025026"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F025026"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F025026"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"40","ma_vt":"F013080"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F013080"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F013080"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"39","ma_vt":"F013080"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F013080"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"37","ma_vt":"F013080"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"36","ma_vt":"F013080"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F013080"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"38","ma_vt":"F013080"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F013080"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F013080"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F013080"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F013080"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F013080"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F013080"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"35","ma_vt":"F013080"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F013080"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F013080"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"39","ma_vt":"F0130802339"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F0130800137"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"37","ma_vt":"F0130802337"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F0130800837"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F0130800136"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F0130800139"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F0130800835"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F0130800839"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F0130800135"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"38","ma_vt":"F0130802338"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F0130800836"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F0130800838"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F0130800140"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F0130800138"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F0130800840"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"35","ma_vt":"F0130802335"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"36","ma_vt":"F0130802336"},{"gia_tri_bien_the_1":"nude","gia_tri_bien_the_2":"40","ma_vt":"F0130802340"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"39","ma_vt":"F025093"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"40","ma_vt":"F025093"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"38","ma_vt":"F025093"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"37","ma_vt":"F025093"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"36","ma_vt":"F025093"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"35","ma_vt":"F025093"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"40","ma_vt":"F025093"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"39","ma_vt":"F025093"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"38","ma_vt":"F025093"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"37","ma_vt":"F025093"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"36","ma_vt":"F025093"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"35","ma_vt":"F025093"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F025093"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F025093"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F025093"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F025093"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F025093"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F025093"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"40","ma_vt":"F025099"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"39","ma_vt":"F025099"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"38","ma_vt":"F025099"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"37","ma_vt":"F025099"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"36","ma_vt":"F025099"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"35","ma_vt":"F025099"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F025099"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F025099"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F025099"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F025099"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F025099"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F025099"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F025099"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F025099"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F025099"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F025099"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F025099"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F025099"},{"gia_tri_bien_the_1":"nâu","gia_tri_bien_the_2":"40","ma_vt":"F025083"},{"gia_tri_bien_the_1":"nâu","gia_tri_bien_the_2":"39","ma_vt":"F025083"},{"gia_tri_bien_the_1":"nâu","gia_tri_bien_the_2":"38","ma_vt":"F025083"},{"gia_tri_bien_the_1":"nâu","gia_tri_bien_the_2":"37","ma_vt":"F025083"},{"gia_tri_bien_the_1":"nâu","gia_tri_bien_the_2":"36","ma_vt":"F025083"},{"gia_tri_bien_the_1":"nâu","gia_tri_bien_the_2":"35","ma_vt":"F025083"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"40","ma_vt":"F025083"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"39","ma_vt":"F025083"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"38","ma_vt":"F025083"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"37","ma_vt":"F025083"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"36","ma_vt":"F025083"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"35","ma_vt":"F025083"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F025083"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F025083"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F025083"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F025083"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F025083"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F025083"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"40","ma_vt":"F027061"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"39","ma_vt":"F027061"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"38","ma_vt":"F027061"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"37","ma_vt":"F027061"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"36","ma_vt":"F027061"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"35","ma_vt":"F027061"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F027061"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F027061"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F027061"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F027061"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F027061"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F027061"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F027061"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F027061"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F027061"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F027061"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F027061"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F027061"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F013108"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F013108"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F013108"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F013108"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F013108"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F013108"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"40","ma_vt":"F013108"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"39","ma_vt":"F013108"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"38","ma_vt":"F013108"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"37","ma_vt":"F013108"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"36","ma_vt":"F013108"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"35","ma_vt":"F013108"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F015019"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F015019"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F015019"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F015019"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F015019"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F015019"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F017051"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F017051"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F017051"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F017051"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F017051"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F017051"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"40","ma_vt":"F017051"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"39","ma_vt":"F017051"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"38","ma_vt":"F017051"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"37","ma_vt":"F017051"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"36","ma_vt":"F017051"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"35","ma_vt":"F017051"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F017051"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F017051"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F017051"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F017051"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F017051"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F017051"},{"gia_tri_bien_the_1":"vàng","gia_tri_bien_the_2":"38","ma_vt":"F017042"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"40","ma_vt":"F017042"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"39","ma_vt":"F017042"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"38","ma_vt":"F017042"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"37","ma_vt":"F017042"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"36","ma_vt":"F017042"},{"gia_tri_bien_the_1":"xám","gia_tri_bien_the_2":"35","ma_vt":"F017042"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"40","ma_vt":"F017042"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"39","ma_vt":"F017042"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"38","ma_vt":"F017042"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"37","ma_vt":"F017042"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"36","ma_vt":"F017042"},{"gia_tri_bien_the_1":"đỏ","gia_tri_bien_the_2":"35","ma_vt":"F017042"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F017042"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F017042"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F017042"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F017042"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F017042"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F017042"},{"gia_tri_bien_the_1":"nâu bò","gia_tri_bien_the_2":"35","ma_vt":"F031150"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"40","ma_vt":"F031150"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"39","ma_vt":"F031150"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"38","ma_vt":"F031150"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"37","ma_vt":"F031150"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"36","ma_vt":"F031150"},{"gia_tri_bien_the_1":"kem","gia_tri_bien_the_2":"35","ma_vt":"F031150"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F031150"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F031150"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F031150"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F031150"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F031150"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"40","ma_vt":"F017095"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"39","ma_vt":"F017095"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"38","ma_vt":"F017095"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"37","ma_vt":"F017095"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"36","ma_vt":"F017095"},{"gia_tri_bien_the_1":"xanh","gia_tri_bien_the_2":"35","ma_vt":"F017095"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"40","ma_vt":"F017095"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"39","ma_vt":"F017095"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"38","ma_vt":"F017095"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"37","ma_vt":"F017095"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"36","ma_vt":"F017095"},{"gia_tri_bien_the_1":"trắng","gia_tri_bien_the_2":"35","ma_vt":"F017095"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"40","ma_vt":"F017095"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"39","ma_vt":"F017095"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"38","ma_vt":"F017095"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"37","ma_vt":"F017095"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"36","ma_vt":"F017095"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F017095"},{"gia_tri_bien_the_1":"đen","gia_tri_bien_the_2":"35","ma_vt":"F031150"}]');
;// CONCATENATED MODULE: ./apis/queryFunctions/dmttFunctions.js




function fetchDmtt(param) {
    var ma_vt = param.ma_vt;
    if (!ma_vt) return null;
    return (0,fetch/* asyncGetList */.NE)({
        access_token: "flex.public.token",
        collection_name: "dmtt",
        options: {
            notfields: [
                "ten_vt",
                "ten_tt",
                "ten_trang_thai",
                "ten_dvt",
                "name_user_created",
                "name_user_updated",
                "ma_dvt",
                "ma_ct",
                "loai_tt",
                "id_app",
                "color",
                "trang_thai", 
            ],
            limit: 200,
            condition: {
                ma_vt: ma_vt
            }
        }
    });
}
function fetchAllDmtt() {
    return (0,fetch/* asyncGetList */.NE)({
        access_token: "flex.public.token",
        collection_name: "dmtt",
        options: {
            limit: 3000,
            fields: [
                "ma_vt",
                "gia_tri_bien_the_1",
                "gia_tri_bien_the_2"
            ]
        }
    });
}
var useFetchDmtt = function(param) {
    var ma_vt = param.ma_vt, _enabled = param.enabled, enabled = _enabled === void 0 ? true : _enabled;
    return (0,useQuery/* useQuery */.a)(queryKeys_dmttKeys.detail(ma_vt), function() {
        return fetchDmtt({
            ma_vt: ma_vt
        });
    }, {
        enabled: !!ma_vt && enabled,
        staleTime: 1000 * 60 * 60
    });
};
var useFetchDmttList = function() {
    return (0,useQuery/* useQuery */.a)(queryKeys_dmttKeys.list(), function() {
        return fetchAllDmtt();
    }, {
        staleTime: 1000 * 60 * 60 * 4,
        initialData: dmtt_namespaceObject
    });
};


/***/ }),

/***/ 30007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K9": function() { return /* binding */ useFetchProduct; },
/* harmony export */   "LZ": function() { return /* binding */ useFetchProducts; },
/* harmony export */   "Tv": function() { return /* binding */ useFetchProductCollection; },
/* harmony export */   "WR": function() { return /* binding */ useFetchProductCount; },
/* harmony export */   "lS": function() { return /* binding */ useFetchHomePageProducts; },
/* harmony export */   "o6": function() { return /* binding */ useFetchStockQuantity; }
/* harmony export */ });
/* unused harmony exports initialOptions, getBestSellerOptions, fetchProduct, CAFE_CATEGORY_IDS, fetchProducts, fetchProductsCount, fetchStocks */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67848);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85945);
/* harmony import */ var _utils_lodash__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59926);
/* harmony import */ var _fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36203);
/* harmony import */ var _queryKeys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76296);








var DEFAULT_STALE_TIME = 60 * 60; // 1 hour
var initialOptions = {
    limit: 10,
    page: 1,
    notfields: [
        "mieu_ta",
        "gia_xuat",
        "tk_vt",
        "gia_ban_buon0",
        "gia_ban_buon",
        "gia_mua",
        "thue_suat_nk0",
        "thue_suat_nk",
        "labels",
        "cong_doan_sx",
        "ma_lvt",
        "ma_nvt",
        "tk_dt",
        "tk_gv",
        "mieu_ta_ngan",
        "name_user_created",
        "name_user_updated",
        "ten_tk_vt",
        "ten_tk_dt",
        "ten_tk_gv",
        "ten_tk_tl",
        "ten_tk_dl",
        "ten_thue", 
    ],
    condition: {
        id_app: "6916a5ba724e967abf28a8ad",
        status: true,
        by_user: true,
        show_properties: true,
        online: true,
        shared: true,
        gia_ban_le: {
            $gte: 0
        }
    },
    sort: {
        date_updated: -1
    }
};
var getBestSellerOptions = function(ma_danh_muc_cty) {
    return {
        limit: 6,
        sort: {
            date_created: -1
        },
        condition: {
            ma_danh_muc_cty: {
                $regex: ma_danh_muc_cty
            }
        }
    };
};
var fetchProduct = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var ma_vt, signal;
        return _var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ma_vt = param.ma_vt, signal = param.signal;
                    return _ctx.abrupt("return", (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetItem */ .p9)({
                        collection_name: "dmvt",
                        signal: signal,
                        options: {
                            condition: {
                                id_app: "6916a5ba724e967abf28a8ad",
                                status: true,
                                ma_vt: ma_vt,
                                shared: true
                            }
                        }
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchProduct(_) {
        return _ref.apply(this, arguments);
    };
}();
var useFetchProduct = function(param) {
    var ma_vt = param.ma_vt;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .productKeys.detail */ .YN.detail(ma_vt), function(param) {
        var signal = param.signal;
        return fetchProduct({
            ma_vt: ma_vt,
            signal: signal
        });
    }, {
        staleTime: DEFAULT_STALE_TIME,
        enabled: !!ma_vt
    });
};
/* -------------------------------------------------------------------------- */ var CAFE_CATEGORY_IDS = [
    "694d03872c12b6001307b391",
    "694d03872c12b6001307b39c"
];
var fetchProducts = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var params, options, token, categories, targetCategories, filtered, conditionCategories, _args = arguments;
        return _var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    params = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                    options = params.options || params;
                    token = params.userToken;
                    categories = params.categories;
                    targetCategories = CAFE_CATEGORY_IDS;
                    if (categories && categories.length > 0) {
                        filtered = categories.filter(function(c) {
                            return CAFE_CATEGORY_IDS.includes(c);
                        });
                        if (filtered.length > 0) {
                            targetCategories = filtered;
                        }
                    }
                    conditionCategories = {
                        $or: [
                            {
                                ma_danh_muc_cty: {
                                    $in: targetCategories
                                }
                            },
                            {
                                ma_nvt: {
                                    $in: targetCategories
                                }
                            }, 
                        ]
                    };
                    _ctx.next = 9;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetList */ .NE)({
                        access_token: token,
                        collection_name: "dmvt",
                        signal: params.signal,
                        options: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, options), {
                            condition: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, options.condition, conditionCategories), {
                                ma_lvt: "TP",
                                shared: true,
                                status: true,
                                gia_theo_kh: true
                            })
                        })
                    });
                case 9:
                    return _ctx.abrupt("return", _ctx.sent);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchProducts() {
        return _ref.apply(this, arguments);
    };
}();
var useFetchProducts = function(options) {
    var queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__/* .useQueryClient */ .NL)();
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .productKeys.list */ .YN.list(options), function(param) {
        var signal = param.signal;
        return fetchProducts({
            options: options,
            signal: signal
        });
    }, {
        enabled: !!options,
        staleTime: DEFAULT_STALE_TIME,
        onSuccess: function(products) {
            products.map(function(product) {
                queryClient.setQueriesData(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .productKeys.detail */ .YN.detail(product === null || product === void 0 ? void 0 : product.ma_vt), product);
            });
        }
    });
};
var useFetchProductCollection = function(options, categories) {
    var token =  true ? JSON.parse(window.localStorage.getItem("token")) || "flex.public.token" : 0;
    var queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__/* .useQueryClient */ .NL)();
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .productKeys.list */ .YN.list((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        page: (options === null || options === void 0 ? void 0 : options.page) || 1,
        sort: options === null || options === void 0 ? void 0 : options.sort
    }, options === null || options === void 0 ? void 0 : options.condition, categories)), function(param) {
        var signal = param.signal;
        return fetchProducts({
            userToken: token,
            options: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, options), {
                limit: 10
            }),
            signal: signal,
            categories: categories
        });
    }, {
        enabled: !(0,_utils_lodash__WEBPACK_IMPORTED_MODULE_8__/* .isEmpty */ .xb)(options),
        staleTime: DEFAULT_STALE_TIME,
        onSuccess: function(products) {
            products.map(function(product) {
                queryClient.setQueriesData(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .productKeys.detail */ .YN.detail(product === null || product === void 0 ? void 0 : product.ma_vt), product);
            });
        }
    });
};
var useFetchHomePageProducts = function(param) {
    var ma_danh_muc_cty = param.ma_danh_muc_cty;
    var queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__/* .useQueryClient */ .NL)();
    var options = getBestSellerOptions(ma_danh_muc_cty);
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .productKeys.homeList */ .YN.homeList(ma_danh_muc_cty), function(param) {
        var signal = param.signal;
        return fetchProducts({
            signal: signal,
            options: options
        });
    }, {
        enabled: Boolean(ma_danh_muc_cty),
        // staleTime: DEFAULT_STALE_TIME,
        onSuccess: function(products) {
            products.map(function(product) {
                queryClient.setQueriesData(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .productKeys.detail */ .YN.detail(product === null || product === void 0 ? void 0 : product.ma_vt), product);
            });
        }
    });
};
/* -------------------------------------------------------------------------- */ var fetchProductsCount = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var _options, options, signal, data;
        return _var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _options = param.options, options = _options === void 0 ? {} : _options, signal = param.signal;
                    _ctx.next = 3;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetList */ .NE)({
                        collection_name: "dmvt",
                        signal: signal,
                        options: {
                            count: true,
                            condition: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (options === null || options === void 0 ? void 0 : options.condition) || {}), {
                                $or: [
                                    {
                                        ma_danh_muc_cty: {
                                            $in: CAFE_CATEGORY_IDS
                                        }
                                    },
                                    {
                                        ma_nvt: {
                                            $in: CAFE_CATEGORY_IDS
                                        }
                                    }, 
                                ],
                                ma_lvt: "TP",
                                status: true,
                                shared: true,
                                gia_theo_kh: true
                            })
                        }
                    });
                case 3:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", (data === null || data === void 0 ? void 0 : data.rows_number) || 0);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchProductsCount(_) {
        return _ref.apply(this, arguments);
    };
}();
var useFetchProductCount = function(param) {
    var options = param.options;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .productKeys.count */ .YN.count(options), function(param) {
        var signal = param.signal;
        return fetchProductsCount({
            options: options,
            signal: signal
        });
    }, {
        staleTime: DEFAULT_STALE_TIME,
        enabled: !(0,_utils_lodash__WEBPACK_IMPORTED_MODULE_8__/* .isEmpty */ .xb)(options)
    });
};
/* -------------------------------------------------------------------------- */ var fetchStocks = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var ma_vt_tt, signal, enabled, url, stocks;
        return _var_www_zemor_vn_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ma_vt_tt = param.ma_vt_tt, signal = param.signal, enabled = param.enabled;
                    _ctx.prev = 1;
                    if (enabled) {
                        _ctx.next = 4;
                        break;
                    }
                    return _ctx.abrupt("return", []);
                case 4:
                    url = "".concat("https://api.flexzen.app", "/api/").concat("6916a5ba724e967abf28a8ad", "/ckvt?access_token=").concat("flex.public.token", '&groupby=["ma_vt"]&ma_vt=').concat(JSON.stringify(ma_vt_tt), "&rpt=1&fields=ton,ma_vt&ma_kho=KCTY");
                    _ctx.next = 7;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGet */ .Bt)(url, signal);
                case 7:
                    stocks = _ctx.sent;
                    return _ctx.abrupt("return", stocks);
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](1);
                    console.error(_ctx.t0);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                11
            ]
        ]);
    }));
    return function fetchStocks(_) {
        return _ref.apply(this, arguments);
    };
}();
var useFetchStockQuantity = function(param) {
    var ma_vt_tt = param.ma_vt_tt, enabled = param.enabled, ma_vt = param.ma_vt;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)([
        {
            scope: "stockQuantity",
            type: "detail",
            ma_vt: ma_vt
        }
    ], function(param) {
        var signal = param.signal;
        return fetchStocks({
            ma_vt_tt: ma_vt_tt,
            signal: signal,
            enabled: enabled
        });
    }, {
        // enabled: !!ma_vt_tt && ma_vt_tt?.length > 0 && enabled,
        // staleTime: 0,
        staleTime: 500 * 60 * 60
    });
};


/***/ }),

/***/ 70625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OutOfStockBadge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



function OutOfStockBadge(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_2__/* .Badge */ .C, {
        color: "dark",
        children: children || "Hết h\xe0ng"
    });
};


/***/ }),

/***/ 26766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _apis_queryFunctions_subscribe__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79122);
/* harmony import */ var _setup_mantine_provider_notifications__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97744);
/* harmony import */ var _utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22312);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(80061);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7414);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(38078);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(95117);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(67841);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(38090);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(19236);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(62679);
/* harmony import */ var _mantine_form__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98903);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34065);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48228);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);














var OutOfStockReminderModal = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_6__.forwardRef(function(param, ref) {
    var _product = param.product, product = _product === void 0 ? {} : _product, selectedSize = param.selectedSize, selectedColor = param.selectedColor, picture_tt = param.picture_tt;
    var isMobile = (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useMediaQuery */ .a)("(max-width: 576px)");
    var _$ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_6__.useState(false), 2), opened = _$ref[0], setOpened = _$ref[1];
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().locale;
    var _$ref1 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__/* .useMutation */ .D)(_apis_queryFunctions_subscribe__WEBPACK_IMPORTED_MODULE_1__/* .postSubscribe */ .L, {
        onSuccess: function(rs) {
            if (rs._id) {
                setOpened(false);
                (0,_setup_mantine_provider_notifications__WEBPACK_IMPORTED_MODULE_2__/* .appAlert */ .t)({
                    type: "success",
                    message: locale === "vi" ? "Đăng k\xed nhận th\xf4ng tin th\xe0nh c\xf4ng!" : "Sign up for information successfully!"
                });
            } else {
                (0,_setup_mantine_provider_notifications__WEBPACK_IMPORTED_MODULE_2__/* .appAlert */ .t)({
                    message: locale === "vi" ? "Đăng k\xfd nhận th\xf4ng tin kh\xf4ng th\xe0nh c\xf4ng" : "Sign up for information failed!"
                });
            }
        }
    }), mutate = _$ref1.mutate, isLoading = _$ref1.isLoading;
    var form = (0,_mantine_form__WEBPACK_IMPORTED_MODULE_10__/* .useForm */ .c)({
        initialValues: {
            email: "",
            termsOfService: false
        },
        validate: {
            email: function(value) {
                return /^\S+@\S+$/.test(value) ? null : locale === "vi" ? "Email kh\xf4ng hợp lệ" : "Invalid email";
            },
            termsOfService: function(val) {
                return val ? null : locale === "vi" ? "Đ\xe1nh dấu v\xe0o \xf4 để tiếp tục." : "Check the box to continue";
            }
        }
    });
    react__WEBPACK_IMPORTED_MODULE_6__.useImperativeHandle(ref, function() {
        return {
            openModal: function openModal() {
                form.reset();
                setOpened(true);
            }
        };
    });
    var handleSubmit = function(email) {
        mutate({
            email: email
        });
    };
    var renderInput = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .TextInput */ .o, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                    my: 20,
                    placeholder: locale === "vi" ? "Địa chỉ email" : "Email"
                }, form.getInputProps("email"))),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_13__/* .Box */ .x, {
                    sx: function() {
                        return {
                            marginTop: "auto"
                        };
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_13__/* .Box */ .x, {
                            mb: 16,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Checkbox */ .X, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                                    label: locale === "vi" ? "T\xf4i đồng \xfd rằng Viet Thien c\xf3 thể li\xean hệ với t\xf4i để cung cấp th\xf4ng tin li\xean quan đến sản phẩm v\xe0 dịch vụ" : "I agree that Viet Thien may contact me to provide information regarding products and services"
                                }, form.getInputProps("termsOfService", {
                                    type: "checkbox"
                                })), {
                                    color: "dark"
                                })),
                                form.errors.termsOfService && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_16__/* .Text */ .x, {
                                    ml: 30,
                                    color: "red",
                                    children: form.errors.termsOfService
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_17__/* .Button */ .z, {
                            color: "dark",
                            variant: "outline",
                            fullWidth: true,
                            type: "submit",
                            loading: isLoading,
                            children: locale === "vi" ? "Gửi" : "Send"
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_18__/* .Modal */ .u, {
        centered: true,
        opened: opened,
        onClose: function() {
            return setOpened(false);
        },
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_19__/* .Title */ .D, {
            order: 5,
            children: locale === "vi" ? "Th\xf4ng b\xe1o cho t\xf4i khi c\xf3 h\xe0ng" : "Notify me when stock is available"
        }),
        size: "xl",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
            onSubmit: form.onSubmit(function(param) {
                var email = param.email;
                return handleSubmit(email);
            }),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_20__/* .Grid */ .r, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_20__/* .Grid.Col */ .r.Col, {
                            span: 5,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                alt: product === null || product === void 0 ? void 0 : product.ten_vt,
                                src: (0,_utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                                    src: picture_tt || (product === null || product === void 0 ? void 0 : product.picture),
                                    size: "m"
                                }),
                                height: 600,
                                width: 600,
                                objectFit: "contain",
                                layout: "responsive",
                                quality: 100
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_20__/* .Grid.Col */ .r.Col, {
                            span: 7,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_13__/* .Box */ .x, {
                                sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    height: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_19__/* .Title */ .D, {
                                        order: 6,
                                        children: locale === "vi" ? product === null || product === void 0 ? void 0 : product.ten_vt : product === null || product === void 0 ? void 0 : product.ten_vt_eng
                                    }),
                                    (selectedColor || selectedSize) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_16__/* .Text */ .x, {
                                        weight: 500,
                                        children: "".concat(selectedColor, ", ").concat(selectedSize)
                                    }),
                                    !isMobile && renderInput()
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_13__/* .Box */ .x, {
                    children: isMobile && renderInput()
                })
            ]
        })
    });
});
OutOfStockReminderModal.displayName = "OutOfStockReminderModal";
/* harmony default export */ __webpack_exports__["Z"] = (OutOfStockReminderModal);


/***/ }),

/***/ 53050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AddToCartButtonGroup; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./setup/locale-provider/index.js
var locale_provider = __webpack_require__(59963);
// EXTERNAL MODULE: ./setup/mantine-provider/notifications.js
var notifications = __webpack_require__(97744);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./common/buttons/CallToActions.js
// import styled from "@emotion/styled";






function CallToAction(_param) {
    var children = _param.children, customStyle = _param.customStyle, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "customStyle"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        sx: function(theme) {
            return (0,_object_spread/* default */.Z)({
                fontSize: 12,
                paddingLeft: 0,
                paddingRight: 0,
                color: "white",
                // borderColor: theme.colors.gray[5],
                backgroundColor: "#000",
                transition: "0.5s",
                "&[data-disabled]": {
                    // color: theme.colors.gray[5],
                    // borderColor: theme.colors.gray[5],
                    backgroundColor: "#00723B"
                },
                "&:hover": {
                    backgroundColor: "#00723B"
                }
            }, customStyle);
        }
    }, props), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./common/buttons/AddToCartButton.js




function AddToCartButton(param) {
    var _compact = param.compact, compact = _compact === void 0 ? true : _compact, _onClickHandler = param.onClickHandler, onClickHandler = _onClickHandler === void 0 ? function() {} : _onClickHandler, _label = param.label, label = _label === void 0 ? "TH\xcaM V\xc0O GIỎ" : _label, _linkToCart = param.linkToCart, linkToCart = _linkToCart === void 0 ? false : _linkToCart, _isStockAvailable = param.isStockAvailable, isStockAvailable = _isStockAvailable === void 0 ? undefined : _isStockAvailable, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _customStyle = param.customStyle, customStyle = _customStyle === void 0 ? {} : _customStyle;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction, {
        compact: compact,
        onClick: function() {
            onClickHandler();
        },
        component: linkToCart ? "a" : "button",
        disabled: isStockAvailable !== true,
        customStyle: (0,_object_spread/* default */.Z)({
            width: "50%"
        }, customStyle),
        loading: loading,
        loaderProps: {
            color: "dark"
        },
        children: label
    });
};

// EXTERNAL MODULE: ./common/ProductController/index.js + 4 modules
var ProductController = __webpack_require__(86433);
;// CONCATENATED MODULE: ./common/Product/AddToCartButtonGroup.js









function AddToCartButtonGroup(param) {
    var slXuat = param.slXuat;
    var ref = (0,router.useRouter)(), push = ref.push, locale = ref.locale;
    var ref1 = (0,ProductController/* useProductController */.t)(), isStockAvailable = ref1.isStockAvailable, isProcessingCart = ref1.isProcessingCart, addToCart = ref1.addToCart, OutOfStockReminderModalRef = ref1.OutOfStockReminderModalRef, effectivePrice = ref1.effectivePrice, originalPrice = ref1.originalPrice;
    if (!effectivePrice && !originalPrice) return null;
    var getLabel = (0,locale_provider/* useLocalContext */.u)().getLabel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isStockAvailable !== false && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button.Group */.z.Group, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartButton, {
                        linkToCart: true,
                        compact: false,
                        label: locale === "vi" ? "MUA NGAY" : "BUY",
                        isStockAvailable: isStockAvailable,
                        loading: isProcessingCart,
                        onClickHandler: function() {
                            if (!isProcessingCart && isStockAvailable) {
                                addToCart(slXuat);
                                push("/cart");
                            }
                        },
                        customStyle: {
                            marginRight: 2
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartButton, {
                        compact: false,
                        loading: isProcessingCart,
                        label: locale === "vi" ? "TH\xcaM V\xc0O GIỎ" : "ADD TO CART",
                        isStockAvailable: isStockAvailable,
                        onClickHandler: function() {
                            if (!isProcessingCart && isStockAvailable) {
                                addToCart(slXuat);
                                (0,notifications/* appAlert */.t)({
                                    type: "success",
                                    message: locale === "vi" ? "Cập nhật giỏ h\xe0ng th\xe0nh c\xf4ng" : "Cart update successful"
                                });
                            }
                        },
                        customStyle: {
                            marginLeft: 2
                        }
                    })
                ]
            }),
            isStockAvailable === false && /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction, {
                compact: false,
                customStyle: {
                    width: "100%",
                    borderRadius: 0
                },
                onClick: function() {
                    OutOfStockReminderModalRef.current.openModal();
                },
                children: locale === "vi" ? "Th\xf4ng b\xe1o khi c\xf3 h\xe0ng" : "Notify when in stock"
            })
        ]
    });
};


/***/ }),

/***/ 28053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CoverImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./common/ProductCard/components/CustomSliderArrows.js
var CustomSliderArrows = __webpack_require__(45716);
// EXTERNAL MODULE: ./utils/appendImageUrlFromAPI.js
var appendImageUrlFromAPI = __webpack_require__(22312);
// EXTERNAL MODULE: ./node_modules/@ant-design/react-slick/es/index.js + 22 modules
var es = __webpack_require__(16530);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Modal/Modal.js + 1 modules
var Modal = __webpack_require__(38090);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/CloseButton/CloseButton.js + 1 modules
var CloseButton = __webpack_require__(80971);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./public/images/placeholder-image.jpeg
var placeholder_image = __webpack_require__(92980);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./pages/san-pham/components/ZoomedImagesModal.js



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .mantine-Modal-modal {\n    padding: 0;\n    overflow: hidden;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var StyledModal = (0,emotion_styled_browser_esm/* default */.Z)(Modal/* Modal */.u)(_templateObject());
function ZoomedImagesModal(param) {
    var isOpen = param.isOpen, images = param.images, handleClose = param.handleClose;
    var zoomedMainSlider = react.useRef();
    var zoomedMainSettings = {
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        initialSlide: 0,
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSliderArrows/* ImageSliderArrows */.T, {}),
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSliderArrows/* ImageSliderArrows */.T, {})
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModal, {
        opened: isOpen,
        onClose: function() {
            return handleClose();
        },
        fullScreen: true,
        withCloseButton: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* CloseButton */.P, {
                sx: function(theme) {
                    return {
                        position: "absolute",
                        right: 10,
                        top: 10,
                        borderRadius: "50%",
                        zIndex: 999,
                        borderColor: theme.colors.gray[4]
                    };
                },
                color: "dark",
                onClick: function() {
                    return handleClose();
                },
                variant: "subtle",
                title: "Close popover",
                size: "xl",
                iconSize: 20,
                style: {
                    outline: "none"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, zoomedMainSettings), {
                ref: zoomedMainSlider,
                children: (images || []).map(function(image, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        sx: {
                            width: "100%",
                            height: "100vh",
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: image.hinh_anh ? (0,appendImageUrlFromAPI/* default */.Z)({
                                src: image.hinh_anh
                            }) : placeholder_image/* default */.Z,
                            alt: "product image",
                            layout: "fill",
                            objectFit: "contain"
                        }, i)
                    }, i);
                })
            }))
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fi/FiChevronLeft.js
var FiChevronLeft = __webpack_require__(2335);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fi/FiChevronRight.js
var FiChevronRight = __webpack_require__(99789);
// EXTERNAL MODULE: ./common/ProductController/index.js + 4 modules
var ProductController = __webpack_require__(86433);
;// CONCATENATED MODULE: ./common/Product/CoverImage.js










function CoverImage(param) {
    var _enableZoom = param.enableZoom, enableZoom = _enableZoom === void 0 ? false : _enableZoom, sliderRef = param.sliderRef, sliderAPI = param.sliderAPI, _showArrows = param.showArrows, showArrows = _showArrows === void 0 ? false : _showArrows, _size = param.size, size = _size === void 0 ? "m" : _size;
    var ref = (0,ProductController/* useProductController */.t)(), allImages = ref.allImages, product = ref.product;
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isZoomed = ref1[0], setIsZoomed = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), prevBtnEnabled = ref2[0], setPrevBtnEnabled = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), nextBtnEnabled = ref3[0], setNextBtnEnabled = ref3[1];
    var onSelect = react.useCallback(function() {
        if (!sliderAPI) return;
        setPrevBtnEnabled(sliderAPI.canScrollPrev());
        setNextBtnEnabled(sliderAPI.canScrollNext());
    }, [
        sliderAPI
    ]);
    // TEMP FIX: carousel not loading initally
    react.useEffect(function() {
        if (!sliderAPI) return;
        sliderAPI.reInit();
    }, [
        sliderAPI
    ]);
    react.useEffect(function() {
        if (!sliderAPI || !onSelect) return;
        onSelect();
        sliderAPI.on("select", onSelect);
    }, [
        sliderAPI,
        onSelect
    ]);
    var scrollPrev = react.useCallback(function() {
        if (sliderAPI) sliderAPI.scrollPrev();
    }, [
        sliderAPI
    ]);
    var scrollNext = react.useCallback(function() {
        if (sliderAPI) sliderAPI.scrollNext();
    }, [
        sliderAPI
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ZoomedImagesModal, {
                isOpen: enableZoom && isZoomed,
                handleClose: function() {
                    return setIsZoomed(false);
                },
                images: allImages,
                product: product
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "productCoverImageSlider",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "productCoverImageSlider__viewport",
                        ref: sliderRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "productCoverImageSlider__container",
                            children: allImages && (allImages === null || allImages === void 0 ? void 0 : allImages.length) > 0 && (allImages === null || allImages === void 0 ? void 0 : allImages.map(function(image, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                    className: "productCoverImageSlider__slide",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: image.hinh_anh ? (0,appendImageUrlFromAPI/* default */.Z)({
                                            src: image.hinh_anh,
                                            size: size
                                        }) : placeholder_image/* default */.Z,
                                        height: 600,
                                        width: 600,
                                        alt: product === null || product === void 0 ? void 0 : product.ten_vt,
                                        objectFit: "contain",
                                        objectPosition: "center",
                                        layout: "responsive",
                                        quality: 85,
                                        onClick: function() {
                                            setIsZoomed(true);
                                        },
                                        priority: index === 0
                                    })
                                }, image === null || image === void 0 ? void 0 : image.hinh_anh);
                            }))
                        })
                    }),
                    showArrows && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "productCoverImageSlider__button productCoverImageSlider__prev",
                        onClick: scrollPrev,
                        type: "button",
                        disabled: !prevBtnEnabled,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FiChevronLeft/* FiChevronLeft */.Y, {})
                    }),
                    showArrows && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "productCoverImageSlider__button productCoverImageSlider__next",
                        onClick: scrollNext,
                        type: "button",
                        disabled: !nextBtnEnabled,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FiChevronRight/* FiChevronRight */.T, {})
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 49752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Price; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38623);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95117);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _ProductController__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86433);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);






function Price() {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    var lienhe = locale === "vi" ? "Li\xean hệ" : "Contact";
    var ref = (0,_ProductController__WEBPACK_IMPORTED_MODULE_3__/* .useProductController */ .t)(), isLoading = ref.isLoading, isDiscounted = ref.isDiscounted, effectivePrice = ref.effectivePrice, originalPrice = ref.originalPrice;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .Skeleton */ .O, {
        visible: isLoading,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                    size: "sm",
                    weight: "normal",
                    sx: function(theme) {
                        return {
                            color: theme.colors.gray[7],
                            display: "inline-block"
                        };
                    },
                    children: effectivePrice ? "".concat(numeral__WEBPACK_IMPORTED_MODULE_1___default()(effectivePrice).format(), " VND") : lienhe
                }),
                isDiscounted && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                    size: "sm",
                    sx: function(theme) {
                        return {
                            color: theme.colors.green[9],
                            // marginLeft: 12,
                            textDecoration: "line-through",
                            display: "inline-block"
                        };
                    },
                    children: originalPrice ? "".concat(numeral__WEBPACK_IMPORTED_MODULE_1___default()(originalPrice).format(), " VND") : lienhe
                })
            ]
        })
    });
};


/***/ }),

/***/ 45716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ ImageSliderArrows; }
/* harmony export */ });
/* unused harmony export ButtonSliderArrows */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _react_icons_all_files_fi_FiChevronLeft__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2335);
/* harmony import */ var _react_icons_all_files_fi_FiChevronRight__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99789);




function ImageSliderArrows(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    if (className.includes("slick-prev")) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiChevronLeft__WEBPACK_IMPORTED_MODULE_1__/* .FiChevronLeft */ .Y, {
            className: className,
            style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                display: "block",
                color: "#fff",
                zIndex: 6,
                backgroundColor: "#000",
                opacity: 0.2,
                width: 24,
                height: 24,
                borderRadius: "50%",
                left: 4
            }, style),
            onClick: onClick
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiChevronRight__WEBPACK_IMPORTED_MODULE_3__/* .FiChevronRight */ .T, {
        className: className,
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            display: "block",
            color: "#fff",
            zIndex: 6,
            backgroundColor: "#000",
            opacity: 0.2,
            width: 24,
            height: 24,
            borderRadius: "50%",
            position: "absolute",
            right: 4
        }, style),
        onClick: onClick
    });
}
function ButtonSliderArrows(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    if (className.includes("slick-prev")) {
        return /*#__PURE__*/ _jsx(FiChevronLeft, {
            className: className,
            style: _object_spread({
                display: "block",
                color: "#000",
                zIndex: 6
            }, style),
            onClick: onClick
        });
    }
    return /*#__PURE__*/ _jsx(FiChevronRight, {
        className: className,
        style: _object_spread({
            display: "block",
            color: "#000",
            zIndex: 6
        }, style),
        onClick: onClick
    });
}


/***/ }),

/***/ 19751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_ProductCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./common/ProductController/index.js + 4 modules
var ProductController = __webpack_require__(86433);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/HoverCard/HoverCard.js + 5 modules
var HoverCard = __webpack_require__(58454);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-resize-observer/use-resize-observer.js
var use_resize_observer = __webpack_require__(12185);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-media-query/use-media-query.js
var use_media_query = __webpack_require__(34065);
// EXTERNAL MODULE: ./common/Modal/OutOfStockReminder/index.js
var OutOfStockReminder = __webpack_require__(26766);
// EXTERNAL MODULE: ./common/Product/AddToCartButtonGroup.js + 2 modules
var AddToCartButtonGroup = __webpack_require__(53050);
;// CONCATENATED MODULE: ./common/ProductCard/components/ProductCardButton.js



function ProductCardButton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartButtonGroup/* default */.Z, {});
};

// EXTERNAL MODULE: ./hooks/usePricing.js
var usePricing = __webpack_require__(14357);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
;// CONCATENATED MODULE: ./common/ProductCard/components/ProductCardDiscountTag.js





function ProductCardDiscount() {
    var product = (0,ProductController/* useProductController */.t)().product;
    var ref = (0,usePricing/* default */.Z)({
        product: product
    }), isDiscounted = ref.isDiscounted, discountPercent = ref.discountPercent;
    return isDiscounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        sx: function(theme) {
            return {
                position: "absolute",
                top: "5%",
                left: "5%",
                backgroundColor: theme.colors.main[5],
                aspectRatio: "1",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: theme.white,
                borderRadius: "50%",
                width: 45,
                height: 45,
                zIndex: 4
            };
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
            size: "lg",
            weight: "500",
            children: "".concat(discountPercent, "%")
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/MediaQuery/MediaQuery.js + 1 modules
var MediaQuery = __webpack_require__(18540);
;// CONCATENATED MODULE: ./common/ProductCard/components/ProductCardHoveringSection.js



function ProductCardHoveringSection(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQuery/* MediaQuery */.z, {
        smallerThan: "xs",
        styles: {
            display: "none"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Dropdown */.z.Dropdown, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                sx: {
                    position: "relative"
                },
                children: children
            })
        })
    });
};

// EXTERNAL MODULE: ./common/Product/CoverImage.js + 1 modules
var CoverImage = __webpack_require__(28053);
// EXTERNAL MODULE: ./hooks/useProductImages.js
var useProductImages = __webpack_require__(53153);
// EXTERNAL MODULE: ./utils/slugifyString.js
var slugifyString = __webpack_require__(91957);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Skeleton/Skeleton.js + 1 modules
var Skeleton = __webpack_require__(38623);
// EXTERNAL MODULE: ./node_modules/embla-carousel-react/embla-carousel-react.esm.js + 1 modules
var embla_carousel_react_esm = __webpack_require__(57434);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./common/ProductCard/components/ProductCardImages.js












function ProductCardImage(param) {
    var children = param.children;
    var hovered = useProductCardContext().hovered;
    var ref = (0,ProductController/* useProductController */.t)(), product = ref.product, selectedColor = ref.selectedColor, isLoading = ref.isLoading, isLoadingDmtt = ref.isLoadingDmtt;
    var selectedImageIndex = (0,useProductImages/* default */.Z)(product, selectedColor).selectedImageIndex;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,embla_carousel_react_esm/* default */.Z)({
        loop: false
    }), 2), sliderRef = ref1[0], sliderAPI = ref1[1];
    react.useEffect(function() {
        if (sliderAPI) {
            var ref;
            sliderAPI === null || sliderAPI === void 0 ? void 0 : (ref = sliderAPI.scrollTo) === null || ref === void 0 ? void 0 : ref.call(sliderAPI, selectedImageIndex, true);
        }
    }, [
        selectedImageIndex,
        sliderAPI
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        sx: {
            position: "relative"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Skeleton/* Skeleton */.O, {
            visible: isLoading && isLoadingDmtt,
            sx: {
                overflow: "visible",
                aspectRatio: "1"
            },
            children: [
                children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    scroll: false,
                    // href={`/san-pham/${slugify(product?.ten_vt)}-${product?.ma_vt}`.toLowerCase()}
                    href: "/san-pham/".concat((0,slugifyString/* default */.Z)(product === null || product === void 0 ? void 0 : product.ten_vt)).toLowerCase(),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        sx: {
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            cursor: "pointer",
                            position: "absolute",
                            zIndex: 2
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    sx: {
                        // top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        cursor: "pointer",
                        position: "absolute",
                        zIndex: 2
                    },
                    children: hovered && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartButtonGroup/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverImage/* default */.Z, {
                    sliderRef: sliderRef,
                    sliderAPI: sliderAPI,
                    size: "s",
                    showArrows: hovered
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./common/Product/Price.js
var Price = __webpack_require__(49752);
;// CONCATENATED MODULE: ./common/ProductCard/components/ProductCardPrice.js




function ProductCardPrice() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        sx: {
            textAlign: "left",
            marginTop: 6
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {})
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./common/ProductCard/components/ProductCardStockTag.js





function ProductCardStockTag() {
    var isStockAvailable = (0,ProductController/* useProductController */.t)().isStockAvailable;
    var locale = (0,router.useRouter)().locale;
    return !isStockAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        sx: function(theme) {
            return {
                position: "absolute",
                top: "5%",
                right: "5%",
                backgroundColor: theme.colors.gray[5],
                aspectRatio: "1",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: theme.white,
                borderRadius: "2px",
                width: 60,
                height: 25,
                zIndex: 4
            };
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
            size: "xs",
            children: locale === "vi" ? "Hết h\xe0ng" : "Sold out"
        })
    });
};

// EXTERNAL MODULE: ./setup/locale-provider/index.js
var locale_provider = __webpack_require__(59963);
;// CONCATENATED MODULE: ./common/ProductCard/components/ProductCardTitle.js








function ProductCardTitle() {
    var checkVisibility = function checkVisibility() {
        if (isMobile) return "visible";
        // if (hovered) return "hidden";
        return "visible";
    };
    var ref = (0,ProductController/* useProductController */.t)(), product = ref.product, isLoading = ref.isLoading;
    var hovered = useProductCardContext().hovered;
    var isMobile = (0,use_media_query/* useMediaQuery */.a)("(max-width: 576px)");
    var getLabel = (0,locale_provider/* useLocalContext */.u)().getLabel;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
        visible: isLoading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
            size: "sm",
            align: "left",
            sx: {
                visibility: checkVisibility(),
                minHeight: 40
            },
            weight: "bold",
            lineClamp: 2,
            children: [
                getLabel(locale === "vi" ? product === null || product === void 0 ? void 0 : product.ten_vt : product === null || product === void 0 ? void 0 : product.ten_vt_eng),
                " "
            ]
        })
    });
};

;// CONCATENATED MODULE: ./common/ProductCard/components/ProductCardVariantSelection.js




function ProductCardVariantSelection(param) {
    var children = param.children;
    var dmtt = (0,ProductController/* useProductController */.t)().dmtt;
    var hasVariants = dmtt && dmtt.length > 0;
    return hasVariants && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        sx: {
            width: "100%",
            marginLeft: "auto",
            marginRight: "auto"
        },
        children: children
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./utils/colorMapping.js + 1 modules
var colorMapping = __webpack_require__(65966);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
;// CONCATENATED MODULE: ./common/buttons/ColorButton.js






function ColorButton(_param) {
    var color = _param.color, isSelected = _param.isSelected, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "isSelected"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, (0,_object_spread/* default */.Z)({
        compact: true,
        sx: function(theme) {
            return {
                background: "".concat((0,colorMapping/* getColorCode */.A)(color), " content-box"),
                aspectRatio: "1",
                borderRadius: "50%",
                width: 28,
                height: 28,
                borderColor: isSelected ? theme.colors.gray[9] : theme.colors.gray[3],
                borderWidth: 2,
                padding: 2,
                "&:hover": {
                    background: "".concat((0,colorMapping/* getColorCode */.A)(color), " content-box")
                }
            };
        }
    }, props));
};

;// CONCATENATED MODULE: ./common/Product/ColorButtonGroup.js




function ColorButtonGroup() {
    var ref = (0,ProductController/* useProductController */.t)(), colors = ref.colors, handleSelectColor = ref.handleSelectColor, selectedColor = ref.selectedColor;
    var sortedColors = colors && (colors === null || colors === void 0 ? void 0 : colors.length) > 0 && colors.sort(function(a, b) {
        if ((a === null || a === void 0 ? void 0 : a.toLowerCase()) < (b === null || b === void 0 ? void 0 : b.toLowerCase())) return 1;
        if ((a === null || a === void 0 ? void 0 : a.toLowerCase()) > (b === null || b === void 0 ? void 0 : b.toLowerCase())) return -1;
        return 0;
    });
    return (sortedColors || []).map(function(color, i) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ColorButton, {
            mr: 8,
            onClick: function() {
                handleSelectColor(color === null || color === void 0 ? void 0 : color.toLowerCase());
            },
            color: color,
            isSelected: (selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.toLowerCase()) === (color === null || color === void 0 ? void 0 : color.toLowerCase())
        }, i);
    });
};

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Group/Group.js + 2 modules
var Group = __webpack_require__(66137);
;// CONCATENATED MODULE: ./common/ProductCard/components/ProductCardVariationColors.js




function ProductCardVariantionColors() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
        position: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorButtonGroup, {})
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@ant-design/react-slick/es/index.js + 22 modules
var es = __webpack_require__(16530);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fi/FiChevronLeft.js
var FiChevronLeft = __webpack_require__(2335);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fi/FiChevronRight.js
var FiChevronRight = __webpack_require__(99789);
;// CONCATENATED MODULE: ./common/ProductCard/components/ProductCardVariationSizes.js









function ProductCardVariationSizes() {
    var getButtonCount = function getButtonCount() {
        if (productCardWidth >= 265) return 6;
        if (productCardWidth >= 220) return 5;
        if (productCardWidth >= 200) return 4;
        return 3;
    };
    var ArrowLeft = function ArrowLeft(param) {
        var className = param.className, style = param.style, onClick = param.onClick;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FiChevronLeft/* FiChevronLeft */.Y, {
            className: className,
            style: (0,_object_spread/* default */.Z)({
                display: "block",
                color: "#000",
                zIndex: 12
            }, style),
            onClick: onClick
        });
    };
    var ArrowRight = function ArrowRight(param) {
        var className = param.className, style = param.style, onClick = param.onClick;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FiChevronRight/* FiChevronRight */.T, {
            className: className,
            style: (0,_object_spread/* default */.Z)({
                display: "block",
                color: "#000",
                zIndex: 12
            }, style),
            onClick: onClick
        });
    };
    // const { renderSizeButtons } = useProductController();
    var productCardWidth = useProductCardContext().productCardWidth;
    var SizeButtonWidth = 26 + 8;
    var settings = {
        dots: false,
        infinite: false,
        centerMode: false,
        slidesToShow: getButtonCount(),
        slidesToScroll: 2,
        arrows: true,
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeft, {}),
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight, {})
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        mt: 4,
        mb: 10,
        sx: {
            marginLeft: "auto",
            marginRight: "auto",
            width: getButtonCount() * SizeButtonWidth
        }
    });
};

;// CONCATENATED MODULE: ./common/ProductCard/components/ProductCartBox.js






function ProductCartBox(param) {
    var children = param.children;
    var product = (0,ProductController/* useProductController */.t)().product;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        scroll: false,
        // href={`/san-pham/${slugify(product?.ten_vt)}-${product?.ma_vt}`.toLowerCase()}
        href: "/san-pham/".concat((0,slugifyString/* default */.Z)(product === null || product === void 0 ? void 0 : product.ten_vt)).toLowerCase(),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
            p: "xs",
            sx: {
                cursor: "pointer"
            },
            children: children
        })
    });
};

// EXTERNAL MODULE: ./common/Badges/OutOfStockBadge.js
var OutOfStockBadge = __webpack_require__(70625);
;// CONCATENATED MODULE: ./common/ProductCard/components/ProductOutOfStockBadge.js





function ProductOutOfStockBadge() {
    var isStockAvailable = (0,ProductController/* useProductController */.t)().isStockAvailable;
    return isStockAvailable === false && /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
        position: "center",
        mb: 10,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OutOfStockBadge/* default */.Z, {})
    });
};

;// CONCATENATED MODULE: ./common/ProductCard/ProductCardView.js




















var ProductCardContext = /*#__PURE__*/ react.createContext();
var useProductCardContext = function() {
    var context = react.useContext(ProductCardContext);
    return context;
};
function ProductCardView(param) {
    var children = param.children;
    var ref = (0,ProductController/* useProductController */.t)(), product = ref.product, selectedColor = ref.selectedColor, selectedSize = ref.selectedSize, OutOfStockReminderModalRef = ref.OutOfStockReminderModalRef, stocks = ref.stocks, dmtt = ref.dmtt, setEnabledFetchingQueries = ref.setEnabledFetchingQueries, picture_tt = ref.picture_tt;
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), hovered = ref1[0], setHovered = ref1[1];
    var ref2 = (0,use_resize_observer/* useElementSize */.h)(), productCardSizeRef = ref2.ref, productCardWidth = ref2.width, productCardHeight = ref2.height;
    var xs = (0,useWindowSize/* default */.Z)().xs;
    var isMobile = (0,use_media_query/* useMediaQuery */.a)("(max-width: ".concat(xs, "px)"), false, {
        getInitialValueInEffect: false
    });
    react.useEffect(function() {
        setEnabledFetchingQueries({
            shouldEnableFetchingDmtt: !dmtt,
            shouldEnableFetchingStock: !stocks
        });
    }, []);
    react.useEffect(function() {
        if (!hovered || isMobile) return;
        setEnabledFetchingQueries({
            shouldEnableFetchingDmtt: !dmtt,
            shouldEnableFetchingStock: !stocks
        });
    }, [
        hovered,
        isMobile,
        dmtt === null || dmtt === void 0 ? void 0 : dmtt.length,
        stocks === null || stocks === void 0 ? void 0 : stocks.length
    ]);
    var value = react.useMemo(function() {
        return {
            hovered: hovered,
            productCardWidth: productCardWidth,
            productCardHeight: productCardHeight
        };
    }, [
        hovered,
        productCardWidth,
        productCardHeight
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardContext.Provider, {
        value: value,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
            sx: {
                position: "relative",
                boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px;",
                transition: "0.3s",
                "&:hover": {
                    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px;"
                }
            },
            ref: productCardSizeRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard */.z, {
                    width: "target",
                    position: "bottom",
                    withArrow: false,
                    shadow: "md",
                    offset: -40,
                    openDelay: dmtt ? 200 : 400,
                    closeDelay: 200,
                    withinPortal: true,
                    onOpen: function() {
                        return setHovered(true);
                    },
                    onClose: function() {
                        return setHovered(false);
                    },
                    middlewares: {
                        flip: false
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Target */.z.Target, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            children: children
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OutOfStockReminder/* default */.Z, {
                    product: product,
                    selectedColor: selectedColor,
                    selectedSize: selectedSize,
                    ref: OutOfStockReminderModalRef,
                    picture_tt: picture_tt
                })
            ]
        })
    });
}
ProductCardView.Title = ProductCardTitle;
ProductCardView.Button = ProductCardButton;
ProductCardView.DiscountTag = ProductCardDiscount;
ProductCardView.Images = ProductCardImage;
ProductCardView.Price = ProductCardPrice;
ProductCardView.Colors = ProductCardVariantionColors;
ProductCardView.Sizes = ProductCardVariationSizes;
ProductCardView.ShowOnHover = ProductCardHoveringSection;
ProductCardView.VariantSelection = ProductCardVariantSelection;
ProductCardView.OutOfStockBadge = ProductOutOfStockBadge;
ProductCardView.Box = ProductCartBox;
ProductCardView.StockTag = ProductCardStockTag;
/* harmony default export */ var ProductCard_ProductCardView = (ProductCardView);

;// CONCATENATED MODULE: ./common/ProductCard/index.js




function ProductCard(param) {
    var product = param.product, isLoading = param.isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductController/* default */.Z, {
        product: product,
        isLoading: isLoading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductCard_ProductCardView, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductCard_ProductCardView.Images, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard_ProductCardView.DiscountTag, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard_ProductCardView.StockTag, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductCard_ProductCardView.Box, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard_ProductCardView.Title, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard_ProductCardView.Price, {})
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var common_ProductCard = (ProductCard);


/***/ }),

/***/ 86433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductController; },
  "t": function() { return /* binding */ useProductController; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./apis/queryFunctions/dmchietkhauFunctions.js
var dmchietkhauFunctions = __webpack_require__(89765);
// EXTERNAL MODULE: ./apis/queryFunctions/dmttFunctions.js + 2 modules
var dmttFunctions = __webpack_require__(60637);
// EXTERNAL MODULE: ./apis/queryFunctions/productFunctions.js
var productFunctions = __webpack_require__(30007);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./hooks/usePrevious.js

function usePrevious(value) {
    var ref = useRef();
    useEffect(function() {
        ref.current = value; //assign the value of ref to the argument
    }, [
        value
    ]); //this code will run when the value of 'value' changes
    return ref.current; //in the end, return the current ref value.
}
/* harmony default export */ var hooks_usePrevious = ((/* unused pure expression or super */ null && (usePrevious)));

// EXTERNAL MODULE: ./hooks/usePricing.js
var usePricing = __webpack_require__(14357);
;// CONCATENATED MODULE: ./hooks/useProductAvailability.js



function useProductAvailability(param) {
    var stocks = param.stocks, product = param.product;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(undefined), 2), isStockAvailable = ref[0], setState = ref[1];
    react.useEffect(function() {
        if (!stocks || stocks.length === 0 && !(product === null || product === void 0 ? void 0 : product.kg_kiem_tra_ton_kho)) {
            setState(false);
            return;
        }
        setState(true);
    }, [
        stocks === null || stocks === void 0 ? void 0 : stocks.length
    ]);
    return isStockAvailable;
};

// EXTERNAL MODULE: ./hooks/useProductImages.js
var useProductImages = __webpack_require__(53153);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-set-state/use-set-state.js
var use_set_state = __webpack_require__(73946);
;// CONCATENATED MODULE: ./hooks/useProductVariations.js




function useProductVariations(dmtt) {
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_set_state/* useSetState */.v)({
        colors: [],
        sizes: [],
        selectedColor: undefined,
        selectedSize: undefined,
        selectedDmtt: undefined
    }), 2), ref1 = ref[0], colors = ref1.colors, sizes = ref1.sizes, selectedColor = ref1.selectedColor, selectedSize = ref1.selectedSize, selectedDmtt = ref1.selectedDmtt, setState = ref[1];
    var handleSelectColor = function(_selectedColor) {
        return setState({
            selectedColor: _selectedColor === null || _selectedColor === void 0 ? void 0 : _selectedColor.toLowerCase()
        });
    };
    var handleSelectSize = function(_selectedSize) {
        return setState({
            selectedSize: _selectedSize
        });
    };
    react.useEffect(function() {
        var ref, ref1;
        if (!dmtt || dmtt.length === 0) return;
        var variants = {};
        dmtt.map(function(el) {
            var ref;
            if (!el.details || el.details.length === 0) return;
            (ref = el.details) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, curr) {
                if (!acc[curr.ma_bien_the]) acc[curr.ma_bien_the] = [];
                if (acc[curr.ma_bien_the] && !acc[curr.ma_bien_the].includes(curr.gia_tri_bien_the)) {
                    acc[curr.ma_bien_the].push(curr.gia_tri_bien_the);
                }
                return acc;
            }, variants);
        });
        var uniqueColors = (0,_to_consumable_array/* default */.Z)(new Set(variants === null || variants === void 0 ? void 0 : (ref = variants.COLOR) === null || ref === void 0 ? void 0 : ref.map(function(el) {
            return el === null || el === void 0 ? void 0 : el.toLowerCase();
        })));
        var uniqueSizes = (0,_to_consumable_array/* default */.Z)(new Set(variants === null || variants === void 0 ? void 0 : (ref1 = variants.SIZE) === null || ref1 === void 0 ? void 0 : ref1.map(Number)));
        var sortedUniqueColors = uniqueColors.sort(function() {
            return 1;
        });
        var sortedUniqueSizes = uniqueSizes.sort(function(a, b) {
            return a - b;
        });
        setState({
            colors: sortedUniqueColors,
            sizes: sortedUniqueSizes
        });
    }, [
        dmtt
    ]);
    react.useEffect(function() {
        if (!colors || colors.length === 0 || !sizes || sizes.length === 0 || !selectedColor || !selectedSize) return;
        var matchingDmtt = dmtt === null || dmtt === void 0 ? void 0 : dmtt.find(function(el) {
            return el.details.every(function(detail) {
                var ref, ref1;
                return ((ref = detail.gia_tri_bien_the) === null || ref === void 0 ? void 0 : ref.toString().toLowerCase()) === (selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.toString().toLowerCase()) || ((ref1 = detail.gia_tri_bien_the) === null || ref1 === void 0 ? void 0 : ref1.toString().toLowerCase()) === (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.toString().toLowerCase());
            });
        });
        setState({
            selectedDmtt: matchingDmtt
        });
    }, [
        sizes,
        colors,
        dmtt,
        selectedColor,
        selectedSize
    ]);
    return {
        colors: colors,
        sizes: sizes,
        selectedColor: selectedColor,
        selectedSize: selectedSize,
        selectedDmtt: selectedDmtt,
        handleSelectColor: handleSelectColor,
        handleSelectSize: handleSelectSize
    };
};

// EXTERNAL MODULE: ./setup/cartProvider/index.js + 2 modules
var cartProvider = __webpack_require__(27104);
// EXTERNAL MODULE: ./setup/mantine-provider/notifications.js
var notifications = __webpack_require__(97744);
;// CONCATENATED MODULE: ./common/buttons/SizeButton.js






function SizeButton(_param) {
    var size = _param.size, selectedSize = _param.selectedSize, isOutOfStock = _param.isOutOfStock, props = _object_without_properties(_param, [
        "size",
        "selectedSize",
        "isOutOfStock"
    ]);
    // console.log(1);
    return /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
        variant: "outline",
        compact: "true",
        sx: function(theme) {
            return _object_spread({
                fontSize: 11,
                paddingLeft: 0,
                paddingRight: 0,
                width: "28px !important",
                height: "28px !important",
                aspectRatio: "1",
                borderRadius: "50%",
                color: selectedSize === size ? theme.colors.gray[9] : theme.colors.gray[5],
                borderColor: selectedSize === size ? theme.colors.gray[9] : theme.colors.gray[5]
            }, isOutOfStock === true && {
                backgroundImage: "url(\"data:image/svg+xml;charset=UTF-8,%3csvg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none'%3e%3cline x1='0' y1='100' x2='100' y2='0' stroke-width='2' fill='black' stroke='%230B2437'/%3e%3c/svg%3e\")",
                // backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none'%3e%3cline x1='0' y1='100' x2='100' y2='0' stroke-width='1' fill='black' stroke='%230B2437'/%3e%3c/svg%3e")`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                backgroundSize: "100% 100%, auto",
                backgroundColor: "transparent"
            });
        }
    }, props), {
        children: size
    }));
};

;// CONCATENATED MODULE: ./common/ProductController/index.js



















var ProductContext = /*#__PURE__*/ react.createContext();
var useProductController = function() {
    var context = react.useContext(ProductContext);
    return context;
};
function ProductController(param) {
    var children = param.children, _product = param.product, product = _product === void 0 ? {} : _product, isLoading = param.isLoading;
    var ref = (0,cartProvider/* useCartContext */.iQ)(), _addToCart = ref.addToCart, isProcessingCart = ref.isProcessingCart;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,use_set_state/* useSetState */.v)({
        shouldEnableFetchingDmtt: false,
        shouldEnableFetchingStock: false
    }), 2), ref2 = ref1[0], shouldEnableFetchingDmtt = ref2.shouldEnableFetchingDmtt, shouldEnableFetchingStock = ref2.shouldEnableFetchingStock, setEnabledFetchingQueries = ref1[1];
    var ref3 = (0,dmttFunctions/* useFetchDmtt */.KA)({
        ma_vt: product === null || product === void 0 ? void 0 : product.ma_vt,
        enabled: shouldEnableFetchingDmtt
    }), dmtt = ref3.data, isLoadingDmtt = ref3.isLoading;
    var ma_vt_tt = [];
    if (dmtt && (dmtt === null || dmtt === void 0 ? void 0 : dmtt.length) > 0) {
        ma_vt_tt = dmtt.map(function(el) {
            return el.ma_tt;
        });
    }
    if (dmtt && (dmtt === null || dmtt === void 0 ? void 0 : dmtt.length) === 0) {
        ma_vt_tt = [
            product === null || product === void 0 ? void 0 : product.ma_vt
        ];
    }
    var ref4 = (0,productFunctions/* useFetchStockQuantity */.o6)({
        ma_vt_tt: ma_vt_tt,
        ma_vt: product === null || product === void 0 ? void 0 : product.ma_vt,
        enabled: (product === null || product === void 0 ? void 0 : product.kg_kiem_tra_ton_kho) ? false : shouldEnableFetchingStock
    }), stocks = ref4.data;
    // console.log("------");
    // console.log("ma_vt_tt", ma_vt_tt);
    // console.log("ma_vt", product?.ma_vt);
    // console.log("stocks", stocks);
    // console.log("------");
    var OutOfStockReminderModalRef = react.useRef();
    var // colors,
    // sizes,
    // selectedColor,
    // selectedSize,
    // handleSelectColor,
    // handleSelectSize,
    selectedDmtt = useProductVariations(dmtt).selectedDmtt;
    // const prevColor = usePrevious(selectedColor);
    var ref5 = (0,productFunctions/* useFetchProduct */.K9)({
        ma_vt: selectedDmtt === null || selectedDmtt === void 0 ? void 0 : selectedDmtt.ma_tt
    }), productVariant = ref5.data;
    var ref6 = (0,dmchietkhauFunctions/* useFetchDmchietkhauByMaVt */.T0)({
        ma_vt: (selectedDmtt === null || selectedDmtt === void 0 ? void 0 : selectedDmtt.ma_tt) || (product === null || product === void 0 ? void 0 : product.ma_vt)
    }), discounts = ref6.data;
    var isStockAvailable = useProductAvailability({
        // dmtt,
        stocks: stocks,
        product: product
    });
    // React.useEffect(() => {
    //   if (prevColor && prevColor !== selectedColor) {
    //     handleSelectSize(null);
    //   }
    // }, [selectedColor, prevColor]);
    var ref7 = (0,useProductImages/* default */.Z)(product), allImages = ref7.allImages, selectedImageIndex = ref7.selectedImageIndex, picture_tt = ref7.picture_tt;
    var ref8 = (0,usePricing/* default */.Z)({
        product: product,
        discounts: discounts,
        productVariant: productVariant
    }), isDiscounted = ref8.isDiscounted, effectivePrice = ref8.effectivePrice, originalPrice = ref8.originalPrice;
    function addToCart() {
        return _addToCart1.apply(this, arguments);
    }
    function _addToCart1() {
        _addToCart1 = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var sl, postData, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        sl = _args.length > 0 && _args[0] !== void 0 ? _args[0] : 1;
                        postData = (0,src_object_spread/* default */.Z)({
                            sl_xuat: sl,
                            ma_dvt: product === null || product === void 0 ? void 0 : product.ma_dvt,
                            thuoc_tinh: (0,src_object_spread/* default */.Z)({
                                shippingInfo: {
                                    chieu_cao: product === null || product === void 0 ? void 0 : product.chieu_cao,
                                    chieu_rong: product === null || product === void 0 ? void 0 : product.chieu_rong,
                                    chieu_sau: product === null || product === void 0 ? void 0 : product.chieu_sau,
                                    trong_luong: product === null || product === void 0 ? void 0 : product.trong_luong
                                },
                                voucher: {}
                            }, selectedDmtt || {}),
                            // id_cs: payload.discount.find((i) => i.ma_cs)?.id_cs,
                            id_app_vt: product === null || product === void 0 ? void 0 : product.id_app,
                            id_app: product === null || product === void 0 ? void 0 : product.id_app,
                            tg_tk: product === null || product === void 0 ? void 0 : product.tg_tk,
                            gia_ban_le: effectivePrice,
                            ma_vt: (selectedDmtt === null || selectedDmtt === void 0 ? void 0 : selectedDmtt.ma_tt) || (product === null || product === void 0 ? void 0 : product.ma_vt),
                            ma_vt_tt: (selectedDmtt === null || selectedDmtt === void 0 ? void 0 : selectedDmtt.ma_tt) || (product === null || product === void 0 ? void 0 : product.ma_vt),
                            picture_tt: picture_tt || (product === null || product === void 0 ? void 0 : product.picture)
                        }, productVariant || {});
                        _addToCart(postData);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _addToCart1.apply(this, arguments);
    }
    // const renderSizeButtons = () => {
    //   if (!sizes || sizes?.length === 0) return null;
    //   return sizes.map((size, i) => (
    //     <SizeButton
    //       key={size}
    //       onClick={() => {
    //         if (!selectedColor) {
    //           appAlert({
    //             message: "Vui lòng chọn màu sắc trước",
    //           });
    //           return;
    //         }
    //         handleSelectSize(size);
    //       }}
    //       size={size}
    //       selectedSize={selectedSize}
    //       // ml={i === 0 ? 0 : 4}
    //       mr={i === size.length - 1 ? 0 : 8}
    //       isOutOfStock={checkIsOutOfStock({
    //         selectedSize: size,
    //         selectedColor,
    //         dmtt,
    //         stocks,
    //       })}
    //     >
    //       {size}
    //     </SizeButton>
    //   ));
    // };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductContext.Provider, {
        value: {
            isLoading: isLoading,
            product: product,
            dmtt: dmtt,
            isLoadingDmtt: isLoadingDmtt,
            addToCart: addToCart,
            // colors,
            // sizes,
            // selectedColor,
            // selectedSize,
            // handleSelectColor,
            // handleSelectSize,
            selectedDmtt: selectedDmtt,
            stocks: stocks,
            isProcessingCart: isProcessingCart,
            discounts: discounts,
            isStockAvailable: isStockAvailable,
            allImages: allImages,
            selectedImageIndex: selectedImageIndex,
            // prevColor,
            isDiscounted: isDiscounted,
            effectivePrice: effectivePrice,
            originalPrice: originalPrice,
            OutOfStockReminderModalRef: OutOfStockReminderModalRef,
            setEnabledFetchingQueries: setEnabledFetchingQueries,
            // renderSizeButtons,
            picture_tt: picture_tt,
            productVariant: productVariant
        },
        children: children
    });
};


/***/ }),

/***/ 14357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73946);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



function calculatePercentage(from, to) {
    if (!from) return 0;
    return (to - from) / from * 100;
}
function calculateDiscountPriceByPercentage(price, discountPercentage) {
    return price - price * (discountPercentage / 100);
}
function usePricing(param) {
    var tmp = param.product, _product = tmp === void 0 ? {
        discount: []
    } : tmp, // selectedDmtt,
    discounts = param.discounts, productVariant = param.productVariant;
    var product = productVariant || _product;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useSetState */ .v)({
        effectivePrice: (product === null || product === void 0 ? void 0 : product.gia_ban_le) || (product === null || product === void 0 ? void 0 : product.gia_ban_le0),
        originalPrice: (product === null || product === void 0 ? void 0 : product.gia_ban_le) || (product === null || product === void 0 ? void 0 : product.gia_ban_le0),
        message: ""
    }), 2), ref1 = ref[0], effectivePrice = ref1.effectivePrice, originalPrice = ref1.originalPrice, message = ref1.message, setState = ref[1];
    var handleUpdateDiscountRate = function(param) {
        var discount = param.discount;
        if (!(discount === null || discount === void 0 ? void 0 : discount.tien_ck) && !(discount === null || discount === void 0 ? void 0 : discount.ty_le_ck)) {
            setState({
                effectivePrice: product.gia_ban_le
            });
            setState({
                originalPrice: product.gia_ban_le
            });
            return;
        }
        if (discount.tien_ck) {
            setState({
                effectivePrice: product.gia_ban_le - discount.tien_ck
            });
            setState({
                originalPrice: product.gia_ban_le
            });
            return;
        }
        if (discount.ty_le_ck) {
            setState({
                effectivePrice: calculateDiscountPriceByPercentage(product.gia_ban_le, discount.ty_le_ck)
            });
            setState({
                originalPrice: product.gia_ban_le
            });
        }
    };
    // initially setting up discount rate
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!product || !product.ma_vt) return;
        var discount = {};
        if (discounts && discounts.length > 0) {
            discount = discounts.find(function(el) {
                return el.ma_vt === product.ma_vt;
            });
        }
        handleUpdateDiscountRate({
            discount: discount
        });
    }, [
        product,
        discounts
    ]);
    // useEffect(() => {
    //   if (!selectedDmtt) return;
    //   let discount = {};
    //   if (discounts && discounts.length > 0) {
    //     discount = discounts.find((el) => el.ma_tt1 === selectedDmtt.ma_tt);
    //   }
    //   // setState({
    //   //   effectivePrice: selectedDmtt.gia_ban_le - (discount?.tien_ck || 0),
    //   //   originalPrice: selectedDmtt.gia_ban_le,
    //   // });
    //   handleUpdateDiscountRate({ discount, product: selectedDmtt });
    // }, [selectedDmtt, discounts]);
    return {
        isDiscounted: effectivePrice < originalPrice,
        effectivePrice: +effectivePrice > 0 ? +effectivePrice : 0,
        originalPrice: +originalPrice,
        discountPercent: +Math.round(calculatePercentage(originalPrice, effectivePrice), 0),
        message: message
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (usePricing);


/***/ }),

/***/ 53153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useProductImages; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var _utils_lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59926);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73946);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);





function useProductImages(product, selectedColor) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useSetState */ .v)({
        allImages: null,
        selectedImageColorVariant: null,
        selectedImageIndex: null,
        picture_tt: null
    }), 2), ref1 = ref[0], allImages = ref1.allImages, selectedImageColorVariant = ref1.selectedImageColorVariant, selectedImageIndex = ref1.selectedImageIndex, picture_tt = ref1.picture_tt, setImages = ref[1];
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        var ref;
        if (!product || (0,_utils_lodash__WEBPACK_IMPORTED_MODULE_3__/* .isEmpty */ .xb)(product)) return;
        var productImages = [];
        if (product === null || product === void 0 ? void 0 : product.picture) {
            productImages.push({
                hinh_anh: product.picture,
                ten_tt1: null
            });
        }
        if (product === null || product === void 0 ? void 0 : product.picture2) {
            productImages.push({
                hinh_anh: product.picture2,
                ten_tt1: null
            });
        }
        if (product === null || product === void 0 ? void 0 : product.picture3) {
            productImages.push({
                hinh_anh: product.picture3,
                ten_tt1: null
            });
        }
        var variationImages = [];
        if ((product === null || product === void 0 ? void 0 : (ref = product.images) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            var ref1;
            variationImages = (ref1 = product.images) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(acc, curr) {
                var ref, ref1, ref2;
                if (curr.hinh_anh) acc.push({
                    hinh_anh: curr.hinh_anh,
                    ten_tt1: (ref = curr.ma_tt3) === null || ref === void 0 ? void 0 : ref.toLowerCase()
                });
                if (curr.hinh_anh_2) acc.push({
                    hinh_anh: curr.hinh_anh_2,
                    ten_tt1: (ref1 = curr.ma_tt3) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()
                });
                if (curr.hinh_anh_3) acc.push({
                    hinh_anh: curr.hinh_anh_3,
                    ten_tt1: (ref2 = curr.ma_tt3) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()
                });
                return acc;
            }, []);
        }
        var sortedVariationImages = [];
        if (variationImages.length > 0) {
            sortedVariationImages = variationImages.sort(function(a, b) {
                if ((a === null || a === void 0 ? void 0 : a.ten_tt1) < (b === null || b === void 0 ? void 0 : b.ten_tt1)) return 1;
                if ((a === null || a === void 0 ? void 0 : a.ten_tt1) > (b === null || b === void 0 ? void 0 : b.ten_tt1)) return -1;
                return 0;
            });
        }
        var images = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(productImages).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(sortedVariationImages));
        setImages({
            allImages: images
        });
    }, [
        product
    ]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        var ref;
        if (!(allImages === null || allImages === void 0 ? void 0 : allImages.length)) return;
        if (!selectedColor) {
            setImages({
                selectedImageIndex: 0
            });
            return;
        }
        var index = allImages.findIndex(function(image) {
            return image.ten_tt1 === selectedColor.toLowerCase();
        });
        setImages({
            selectedImageIndex: index || 0,
            picture_tt: allImages === null || allImages === void 0 ? void 0 : (ref = allImages[index]) === null || ref === void 0 ? void 0 : ref.hinh_anh
        });
    }, [
        selectedColor,
        allImages
    ]);
    return {
        allImages: allImages,
        selectedImageColorVariant: selectedImageColorVariant,
        // handleSelectImage,
        selectedImageIndex: selectedImageIndex,
        picture_tt: picture_tt
    };
};


/***/ }),

/***/ 65966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ getColorCode; }
});

// UNUSED EXPORTS: colorsMaps

// EXTERNAL MODULE: ./utils/slugifyString.js
var slugifyString = __webpack_require__(91957);
;// CONCATENATED MODULE: ./utils/compareStrings.js

function compareStrings(str1, str2) {
    if (!str1 || !str2 || typeof str1 !== "string" || typeof str2 !== "string") return false;
    return (0,slugifyString/* default */.Z)(str1) === (0,slugifyString/* default */.Z)(str2);
};

;// CONCATENATED MODULE: ./utils/colorMapping.js

var colorsMaps = {
    "n\xe2u b\xf2": "#ae693d",
    vàng: "#e9d55e",
    "xanh ngọc": "#adbec3",
    trắng: "#ffffff",
    kem: "#f3dfab",
    đen: "#000000",
    xanh: "#1c72bd",
    xám: "#aaaaaa",
    nâu: "#ae693d",
    "xanh mint": "#04d9b2",
    rêu: "#193919",
    "xanh navy": "#2e5b7c",
    tím: "#6a4aad",
    hồng: "#f79ab9",
    "nhũ bạc": "#9fa2b2",
    bạc: "#bec2cb",
    đỏ: "#dd3234",
    nude: "#fadbd4",
    "xanh dương": "#7bc8ed",
    "xanh da trời": "#7bc8ed",
    bò: "#ae693d",
    "kem mờ": "#f9f0d8"
};
function getColorCode(colorName) {
    if (!colorName || typeof colorName !== "string") return null;
    var colorCode = "green";
    for(var key in colorsMaps){
        if (compareStrings(key, colorName)) {
            colorCode = colorsMaps[key];
        }
    }
    return colorCode;
}


/***/ }),

/***/ 91957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ slugify; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);

function convert_vi_to_en(str) {
    if (!(typeof str === "string" || (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(str, String))) return "";
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
    str = str.replace(/Đ/g, "D");
    str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
    str = str.replace(/  +/g, " ");
    return str;
}
function slugify(string) {
    var denicodeString = convert_vi_to_en(string);
    return denicodeString.toString().normalize("NFKD").toLowerCase().trim().replace(/\s+/g, "-").replace(/[^\w\-]+/g, "").replace(/\-\-+/g, "-");
};


/***/ })

}]);